/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Long: { input: any; output: any; }
  OptionalFloat: { input: any; output: any; }
  OptionalInt: { input: any; output: any; }
  OptionalString: { input: any; output: any; }
  OptionalUUID: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AcceptInvitationInput = {
  firstName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};

export type Account = {
  __typename?: 'Account';
  calendarEvents?: Maybe<Array<CalendarEvent>>;
  calendars?: Maybe<Array<Calendar>>;
  datePreferences?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailAccounts: Array<EmailAccount>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  googleAccountEmail?: Maybe<Scalars['String']['output']>;
  googleCalendarAuthorizationUrl: Scalars['String']['output'];
  havelockEnabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isGoogleCalendarEnabled: Scalars['Boolean']['output'];
  isGuest: Scalars['Boolean']['output'];
  isOutlookCalendarEnabled: Scalars['Boolean']['output'];
  isTeamLead: Scalars['Boolean']['output'];
  jobTitle?: Maybe<JobTitle>;
  keyMilestonesSettings: KeyMilestonesSettings;
  lang: Language;
  lastName?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  outlookAccountEmail?: Maybe<Scalars['String']['output']>;
  outlookCalendarAuthorizationUrl: Scalars['String']['output'];
  permissions: Array<Permission>;
  playThreadNotificationSound: Scalars['Boolean']['output'];
  prodactiveEnabled: Scalars['Boolean']['output'];
  productionPlanningSettings: ProductionPlanningSettings;
  profileImage?: Maybe<Resource>;
  roles: Array<Role>;
  showOnlyNewThreadsActivity: Scalars['Boolean']['output'];
  teams?: Maybe<Array<Team>>;
  timezone?: Maybe<Scalars['String']['output']>;
  widgets: Array<Widget>;
};


export type AccountCalendarEventsArgs = {
  from?: InputMaybe<TimestampInput>;
  to?: InputMaybe<TimestampInput>;
};

export type AccountEvent = Event & {
  __typename?: 'AccountEvent';
  account: Account;
  type: EventType;
};

export type ActivateStandbyTaskInput = {
  assignees: Array<Scalars['UUID']['input']>;
  customDuplicateTasks?: InputMaybe<Array<DuplicateTaskInput>>;
  deadline: TimestampInput;
  description?: InputMaybe<Scalars['String']['input']>;
  emailees?: InputMaybe<Array<Scalars['UUID']['input']>>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  followers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  resources?: InputMaybe<Array<SaveResourceInput>>;
  standbyTaskId: Scalars['UUID']['input'];
  teamFollowerIds?: Array<Scalars['UUID']['input']>;
};

export type AddFashionCollectionToSectionInput = {
  itemId: Scalars['UUID']['input'];
  sectionId: Scalars['UUID']['input'];
};

export type AddProcedureMilestoneInput = {
  baseMilestoneId: Scalars['UUID']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  labelId?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  procedureId: Scalars['UUID']['input'];
};

export type AddProcedureTaskInput = {
  assignees?: Array<ProcedureTaskAssigneeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  procedureMilestoneId: Scalars['UUID']['input'];
};

export type AdditionalReferenceNumber = {
  __typename?: 'AdditionalReferenceNumber';
  name: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
};

export type AdditionalReferenceNumberInput = {
  name: Scalars['String']['input'];
  referenceNumber: Scalars['String']['input'];
};

export type AdditionalTaskFiltersInput = {
  assignedByMe?: Scalars['Boolean']['input'];
  assignedToMe?: Scalars['Boolean']['input'];
  following?: Scalars['Boolean']['input'];
};

export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  contactPerson?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type AdjustMaterialsInput = {
  documents?: Array<TransactionDocumentInput>;
  materials: Array<AdjustTransactionMaterialInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  stockRequestId?: InputMaybe<Scalars['UUID']['input']>;
  warehouseId: Scalars['UUID']['input'];
};

export type AdjustTransactionMaterialInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  materialId?: InputMaybe<Scalars['UUID']['input']>;
  newMaterial?: InputMaybe<SaveMaterialInput>;
  quantity: Scalars['Int']['input'];
};

export enum Application {
  Havelock = 'HAVELOCK',
  Prodactive = 'PRODACTIVE'
}

export type AssignProducerInput = {
  endDate: TimestampInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfWorkers?: InputMaybe<Scalars['Int']['input']>;
  producerId: Scalars['UUID']['input'];
  productionTime?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
  startDate: TimestampInput;
};

export type AssignedProducer = {
  __typename?: 'AssignedProducer';
  allowedStatuses: Array<ProductionPlanningStatus>;
  endDate: Timestamp;
  id: Scalars['UUID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  numberOfWorkers?: Maybe<Scalars['Int']['output']>;
  plannedAt?: Maybe<Timestamp>;
  plannedBy: Account;
  producedQuantity: Scalars['Int']['output'];
  producer: Producer;
  productionTime?: Maybe<Scalars['Int']['output']>;
  quantityToProduce: Scalars['Int']['output'];
  startDate: Timestamp;
  status: ProductionPlanningStatus;
  trackings: Array<ProducerTracking>;
};

export type BaseMilestone = {
  __typename?: 'BaseMilestone';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCheckpoint: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type BaseMilestoneSorterInput = {
  baseMilestoneId: Scalars['UUID']['input'];
  direction: SortDirection;
};

export type BaseMilestones = {
  __typename?: 'BaseMilestones';
  baseMilestones?: Maybe<Array<BaseMilestone>>;
  meta?: Maybe<Metadata>;
};

export type BaseUsageReportRow = {
  account: Account;
  assignedGoals?: Maybe<Scalars['Int']['output']>;
  assignedTasks?: Maybe<Scalars['Int']['output']>;
  completedGoals?: Maybe<Scalars['Int']['output']>;
  completedTasks?: Maybe<Scalars['Int']['output']>;
  createdGoals?: Maybe<Scalars['Int']['output']>;
  createdTasks?: Maybe<Scalars['Int']['output']>;
  receivedNotifications?: Maybe<Scalars['Int']['output']>;
};

export type Board = {
  __typename?: 'Board';
  id: Scalars['UUID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: Account;
  sections: Array<Section>;
  teamContributors: Array<TeamContributor>;
  userAccess?: Maybe<UserAccess>;
  userContributors: Array<UserContributor>;
  userSettings: BoardUserSettings;
};

export type BoardEvent = Event & {
  __typename?: 'BoardEvent';
  board: Board;
  type: EventType;
};

export type BoardEventUnion = BoardEvent | EntityDeletedEvent;

export enum BoardField {
  IsArchived = 'IS_ARCHIVED',
  Name = 'NAME',
  Owner = 'OWNER'
}

export type BoardFilterInput = {
  field: BoardField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type BoardSorterInput = {
  direction: SortDirection;
  field: BoardField;
};

export type BoardUserSettings = {
  __typename?: 'BoardUserSettings';
  isFavourite: Scalars['Boolean']['output'];
  showCompletedGoals: Scalars['Boolean']['output'];
};

export type Boards = {
  __typename?: 'Boards';
  boards: Array<Board>;
  meta: Metadata;
};

export type BoardsSetFilterInput = {
  field: BoardField;
  filters?: Array<BoardFilterInput>;
};

export type CalculateMilestoneDeadlineInput = {
  isAfterProjectEnd: Scalars['Boolean']['input'];
  milestoneId: Scalars['UUID']['input'];
};

export type CalculateMilestoneDeadlinesInput = {
  calculateFromProjectStart: Scalars['Boolean']['input'];
  milestones: Array<CalculateMilestoneDeadlineInput>;
  projectDate?: InputMaybe<TimestampInput>;
};

export type Calendar = {
  __typename?: 'Calendar';
  id: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: CalendarType;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  fromDate?: Maybe<Timestamp>;
  fromTime?: Maybe<Timestamp>;
  link: Scalars['String']['output'];
  meetingLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Timestamp>;
  toTime?: Maybe<Timestamp>;
};

export enum CalendarType {
  Google = 'GOOGLE',
  Outlook = 'OUTLOOK'
}

export type Categories = {
  __typename?: 'Categories';
  categoriesList?: Maybe<Array<Maybe<Category>>>;
  meta?: Maybe<Metadata>;
};

export type Category = {
  __typename?: 'Category';
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefaultType?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ChangeType {
  AssigneeChanged = 'ASSIGNEE_CHANGED',
  DeadlineChanged = 'DEADLINE_CHANGED',
  DescriptionChanged = 'DESCRIPTION_CHANGED',
  DurationChanged = 'DURATION_CHANGED',
  DynamicPlannerChanged = 'DYNAMIC_PLANNER_CHANGED',
  EstimatedHoursChanged = 'ESTIMATED_HOURS_CHANGED',
  ExecutionDateChanged = 'EXECUTION_DATE_CHANGED',
  FollowerChanged = 'FOLLOWER_CHANGED',
  GoalDeleted = 'GOAL_DELETED',
  LabelChanged = 'LABEL_CHANGED',
  NameChanged = 'NAME_CHANGED',
  NotesChanged = 'NOTES_CHANGED',
  OwnerChanged = 'OWNER_CHANGED',
  PositionChanged = 'POSITION_CHANGED',
  SectionChanged = 'SECTION_CHANGED',
  StatusChanged = 'STATUS_CHANGED',
  TaskDeleted = 'TASK_DELETED'
}

export type CheckInvitationInput = {
  id: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
  timezone: Scalars['String']['input'];
};

export type CheckInvitationResponse = {
  __typename?: 'CheckInvitationResponse';
  havelockEnabled: Scalars['Boolean']['output'];
  isAutoAccepted: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  organizationLanguage?: Maybe<Language>;
  prodactiveEnabled: Scalars['Boolean']['output'];
};

export type Client = {
  __typename?: 'Client';
  contactDetails: ContactDetails;
  contacts: Array<Contact>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Clients = {
  __typename?: 'Clients';
  clients?: Maybe<Array<Client>>;
  meta?: Maybe<Metadata>;
};

export enum ClientsField {
  Address = 'ADDRESS',
  Email = 'EMAIL',
  IsActive = 'IS_ACTIVE',
  Name = 'NAME',
  Notes = 'NOTES',
  Phone = 'PHONE'
}

export type Comment = {
  __typename?: 'Comment';
  createdAt: Timestamp;
  deadlineRequest?: Maybe<DeadlineRequest>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  fashionCollectionItem?: Maybe<FashionCollectionItem>;
  goal?: Maybe<Goal>;
  id: Scalars['UUID']['output'];
  inboundEmailEnvelope?: Maybe<EmailEnvelope>;
  likeDetails: LikeDetails;
  likedBy: Array<Account>;
  onBehalfOf?: Maybe<Account>;
  outboundEmailEnvelope?: Maybe<EmailEnvelope>;
  parentCommentId?: Maybe<Scalars['UUID']['output']>;
  recipients: CommentRecipients;
  reminder?: Maybe<CommentReminder>;
  resources?: Maybe<Array<Resource>>;
  task?: Maybe<Task>;
  text: Scalars['String']['output'];
  thread?: Maybe<Thread>;
  updatedAt?: Maybe<Timestamp>;
  user: Account;
};

export enum CommentEntityType {
  Goal = 'GOAL',
  Task = 'TASK',
  Thread = 'THREAD'
}

export type CommentEvent = Event & {
  __typename?: 'CommentEvent';
  comment: Comment;
  type: EventType;
};

export type CommentEventUnion = CommentEvent | EntityDeletedEvent;

export enum CommentField {
  CreatedAt = 'CREATED_AT',
  PostedIn = 'POSTED_IN',
  Text = 'TEXT',
  User = 'USER'
}

export type CommentFilterInput = {
  field: CommentField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type CommentRecipientTeam = {
  __typename?: 'CommentRecipientTeam';
  isRead: Scalars['Boolean']['output'];
  sendEmail: Scalars['Boolean']['output'];
  team: Team;
};

export type CommentRecipientUser = {
  __typename?: 'CommentRecipientUser';
  isRead: Scalars['Boolean']['output'];
  isTeamMember: Scalars['Boolean']['output'];
  sendEmail: Scalars['Boolean']['output'];
  user: Account;
};

export type CommentRecipients = {
  __typename?: 'CommentRecipients';
  teams: Array<CommentRecipientTeam>;
  users: Array<CommentRecipientUser>;
};

export type CommentReminder = {
  __typename?: 'CommentReminder';
  id: Scalars['UUID']['output'];
  remindAt: Timestamp;
  type: ReminderType;
};

export type CommentSorterInput = {
  direction: SortDirection;
  field: CommentField;
};

export type Comments = {
  __typename?: 'Comments';
  comments: Array<Comment>;
  meta: Metadata;
};

export type CommentsReadEvent = {
  __typename?: 'CommentsReadEvent';
  account: Account;
  readAt: Timestamp;
};

export type CommentsSetFilterInput = {
  field: CommentField;
  filters?: Array<Array<CommentFilterInput>>;
};

export type CommentsState = {
  __typename?: 'CommentsState';
  hasComments: Scalars['Boolean']['output'];
  unreadCommentsCount: Scalars['Int']['output'];
};

export type Consumption = {
  __typename?: 'Consumption';
  consumption: Scalars['Float']['output'];
  totalQuantity: Scalars['Float']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  contactDetails?: Maybe<ContactDetails>;
  contactType?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['UUID']['output']>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type ContactDetailsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export enum ContextType {
  Comment = 'COMMENT',
  FashionCollectionItem = 'FASHION_COLLECTION_ITEM',
  Goal = 'GOAL',
  Material = 'MATERIAL',
  Milestone = 'MILESTONE',
  Project = 'PROJECT',
  Task = 'TASK',
  Transaction = 'TRANSACTION'
}

export type ConvertThreadToGoalInput = {
  goal: SaveGoalInput;
  id: Scalars['UUID']['input'];
  shouldCopyComments?: Scalars['Boolean']['input'];
  shouldKeepThread?: Scalars['Boolean']['input'];
};

export type ConvertThreadToTaskInput = {
  id: Scalars['UUID']['input'];
  shouldCopyComments?: Scalars['Boolean']['input'];
  shouldKeepThread?: Scalars['Boolean']['input'];
  task: SaveTaskInput;
};

export type CopyProcedureInput = {
  deselectedMilestones?: Array<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sourceProcedureId: Scalars['UUID']['input'];
  title: Scalars['String']['input'];
};

export type CopyProjectMaterialsInput = {
  ownerId: Scalars['UUID']['input'];
  projectMaterialIds: Array<Scalars['UUID']['input']>;
  targetDeadline?: InputMaybe<TimestampInput>;
  targetDeadlineMilestoneId?: InputMaybe<Scalars['UUID']['input']>;
  toProjectId: Scalars['UUID']['input'];
};

export type CountEvent = {
  __typename?: 'CountEvent';
  value: Scalars['Int']['output'];
};

export enum CounterType {
  ProjectMaterials = 'PROJECT_MATERIALS',
  ProjectMilestones = 'PROJECT_MILESTONES',
  ProjectResources = 'PROJECT_RESOURCES',
  ProjectSizeMatrices = 'PROJECT_SIZE_MATRICES',
  TaskComments = 'TASK_COMMENTS',
  TaskResources = 'TASK_RESOURCES',
  UserAssignedTodos = 'USER_ASSIGNED_TODOS',
  UserReminders = 'USER_REMINDERS',
  UserUnreadThreads = 'USER_UNREAD_THREADS'
}

export type Counters = {
  __typename?: 'Counters';
  accountId?: Maybe<Scalars['UUID']['output']>;
  dynamicPlannings: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
  tasks: TaskCounters;
  todos: TaskCounters;
};

export type CreateEmailMessageIdInput = {
  emailAccountId: Scalars['UUID']['input'];
  messageId: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  account: SaveAccountInput;
  currency: Currency;
  havelockEnabled: Scalars['Boolean']['input'];
  industry?: InputMaybe<OrganizationIndustry>;
  language: Language;
  name: Scalars['String']['input'];
  prodactiveEnabled: Scalars['Boolean']['input'];
  type: OrganizationType;
};

export type CreateSignatureInput = {
  images?: InputMaybe<Array<SaveResourceInput>>;
  name: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

export enum Currency {
  Bgn = 'BGN',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CustomFieldDefinition = {
  __typename?: 'CustomFieldDefinition';
  createdBy: Account;
  description?: Maybe<Scalars['String']['output']>;
  enumEntries?: Maybe<Array<CustomFieldEnumEntry>>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  table: Table;
  teamContributors: Array<TeamContributor>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type: CustomFieldType;
  userContributors: Array<UserContributor>;
};

export type CustomFieldEnumEntry = {
  __typename?: 'CustomFieldEnumEntry';
  displayName: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type CustomFieldFilterInput = {
  fieldName: Scalars['String']['input'];
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type CustomFieldSorterInput = {
  direction: SortDirection;
  fieldName: Scalars['String']['input'];
};

export enum CustomFieldType {
  Account = 'ACCOUNT',
  Date = 'DATE',
  Enum = 'ENUM',
  MultiEnum = 'MULTI_ENUM',
  MultiId = 'MULTI_ID',
  Number = 'NUMBER',
  String = 'STRING'
}

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  dateValue?: Maybe<Timestamp>;
  definition: CustomFieldDefinition;
  idValue?: Maybe<Scalars['UUID']['output']>;
  multiIdValue?: Maybe<Array<Scalars['UUID']['output']>>;
  multiStringValue?: Maybe<Array<Scalars['String']['output']>>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldValueInput = {
  dateValue?: InputMaybe<TimestampInput>;
  fieldName: Scalars['String']['input'];
  idValue?: InputMaybe<Scalars['UUID']['input']>;
  multiIdValue?: InputMaybe<Array<Scalars['UUID']['input']>>;
  multiStringValue?: InputMaybe<Array<Scalars['String']['input']>>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardCounterInput = {
  from: TimestampInput;
  to: TimestampInput;
};

export type DashboardCounters = {
  __typename?: 'DashboardCounters';
  completedGoals: Scalars['Int']['output'];
  completedTasks: Scalars['Int']['output'];
  completedTodos: Scalars['Int']['output'];
  postedComments: Scalars['Int']['output'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeadlineRequest = {
  __typename?: 'DeadlineRequest';
  proposedDeadline?: Maybe<Timestamp>;
  setDeadline?: Maybe<Timestamp>;
  status?: Maybe<DeadlineRequestStatus>;
  task: Task;
};

export type DeadlineRequestInput = {
  proposedDeadline?: InputMaybe<TimestampInput>;
  setDeadline?: InputMaybe<TimestampInput>;
  status?: InputMaybe<DeadlineRequestStatus>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum DeadlineRequestStatus {
  Accepted = 'ACCEPTED',
  Custom = 'CUSTOM',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type DeleteCommentReminderInput = {
  commentId: Scalars['UUID']['input'];
};

export type DeleteContactInput = {
  contactIds: Array<Scalars['UUID']['input']>;
};

export type DeleteInvitationInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLabelInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLoggedTimeInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteMilestoneInput = {
  milestoneId: Scalars['UUID']['input'];
};

export type DeleteProcedureMilestoneInput = {
  milestoneIds: Array<Scalars['UUID']['input']>;
};

export type DeleteProcedureTasksInput = {
  procedureTaskIds: Array<Scalars['UUID']['input']>;
};

export type DeleteResource = {
  __typename?: 'DeleteResource';
  failedIds?: Maybe<Array<Scalars['UUID']['output']>>;
};

export type DeleteResourcesInput = {
  ids: Array<Scalars['UUID']['input']>;
};

export type DeleteSectionInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteSizeInput = {
  sizeIds: Array<Scalars['UUID']['input']>;
};

export type DeleteSizeMatrixInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteTranslationInput = {
  key: Scalars['String']['input'];
  language: Language;
};

export type DuplicateTaskInput = {
  assigneeId: Scalars['UUID']['input'];
  deadline?: InputMaybe<TimestampInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type DynamicPlanning = {
  __typename?: 'DynamicPlanning';
  dynamicPlanner: Timestamp;
  goal?: Maybe<Goal>;
  keyMilestonesProject?: Maybe<Project>;
  materialsProductionRequest?: Maybe<MaterialsProductionRequest>;
  milestone?: Maybe<Milestone>;
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  productionPlanningProject?: Maybe<Project>;
  project?: Maybe<Project>;
  projectMaterial?: Maybe<ProjectMaterial>;
  task?: Maybe<Task>;
  tasksMeta?: Maybe<TasksMetadata>;
  thread?: Maybe<Thread>;
};

export type DynamicPlanningEvent = Event & {
  __typename?: 'DynamicPlanningEvent';
  dynamicPlanning: DynamicPlanning;
  type: EventType;
};

export type DynamicPlanningEventUnion = DynamicPlanningEvent | EntityDeletedEvent;

export type EditTasksAssigneesInput = {
  addedAssignees?: InputMaybe<Array<TaskAssigneeInput>>;
  emailees?: InputMaybe<Array<Scalars['UUID']['input']>>;
  removedAssignees?: InputMaybe<Array<Scalars['UUID']['input']>>;
  replacedAssignees?: InputMaybe<Array<ReplaceTaskAssigneeInput>>;
  rootTaskDeadline?: InputMaybe<TimestampInput>;
  rootTaskId: Scalars['UUID']['input'];
};

export type EmailAccount = {
  __typename?: 'EmailAccount';
  account: Account;
  contacts: Array<EmailContact>;
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  imapSettings?: Maybe<ImapSettings>;
  isDisconnected: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  newEmailSignature?: Maybe<EmailSignature>;
  otherAccounts: Array<Account>;
  replySignature?: Maybe<EmailSignature>;
  type: EmailAccountType;
};

export enum EmailAccountType {
  Google = 'GOOGLE',
  Imap = 'IMAP',
  Outlook = 'OUTLOOK'
}

export type EmailContact = {
  __typename?: 'EmailContact';
  emails: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type EmailEnvelope = {
  __typename?: 'EmailEnvelope';
  bcc: Array<EmailInternetAddress>;
  cc: Array<EmailInternetAddress>;
  from: EmailInternetAddress;
  subject: Scalars['String']['output'];
  to: Array<EmailInternetAddress>;
};

export type EmailEnvelopeInput = {
  bcc?: Array<EmailInternetAddressInput>;
  cc?: Array<EmailInternetAddressInput>;
  from: Scalars['UUID']['input'];
  isForward?: Scalars['Boolean']['input'];
  subject: Scalars['String']['input'];
  to: Array<EmailInternetAddressInput>;
};

export type EmailInternetAddress = {
  __typename?: 'EmailInternetAddress';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EmailInternetAddressInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailLinkableEntityType {
  Goal = 'GOAL',
  Task = 'TASK'
}

export type EmailLinkedEntity = {
  __typename?: 'EmailLinkedEntity';
  entity: EmailLinkedEntityEntity;
  id: Scalars['UUID']['output'];
  shouldPostReplies: Scalars['Boolean']['output'];
};

export type EmailLinkedEntityEntity = Goal | Task;

export type EmailMessageIdInput = {
  emailAccountId: Scalars['UUID']['input'];
  messageId: Scalars['String']['input'];
};

export type EmailSignature = {
  __typename?: 'EmailSignature';
  id: Scalars['UUID']['output'];
  images: Array<Resource>;
  name: Scalars['String']['output'];
  signature: Scalars['String']['output'];
};

export type EmptyResponse = {
  __typename?: 'EmptyResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EntityDeletedEvent = {
  __typename?: 'EntityDeletedEvent';
  entityId: Scalars['UUID']['output'];
};

export enum EntityType {
  Goal = 'GOAL',
  Milestone = 'MILESTONE',
  Task = 'TASK'
}

export type EnumEntryUpdateInput = {
  displayName: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorsResponse = {
  __typename?: 'ErrorsResponse';
  errors: Array<ErrorResponse>;
};

export type Event = {
  type?: Maybe<EventType>;
};

export enum EventType {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export type ExportProjectsInput = {
  customFieldFilters?: Array<CustomFieldFilterInput>;
  customFieldSorter?: InputMaybe<CustomFieldSorterInput>;
  filters?: InputMaybe<Array<Array<ProjectFilterInput>>>;
  includeTrackedMilestones?: Scalars['Boolean']['input'];
  milestoneDateFilters?: Array<MilestoneDateFilterInput>;
  milestoneSorter?: InputMaybe<BaseMilestoneSorterInput>;
  selectedColumns?: InputMaybe<Array<SelectedColumns>>;
  sorters?: InputMaybe<Array<ProjectSorterInput>>;
};

export type ExternalEmailEnvelopeInput = {
  bcc?: Array<EmailInternetAddressInput>;
  cc?: Array<EmailInternetAddressInput>;
  from: EmailInternetAddressInput;
  id: Scalars['String']['input'];
  isForward?: Scalars['Boolean']['input'];
  subject: Scalars['String']['input'];
  to: Array<EmailInternetAddressInput>;
};

export type FashionCollection = {
  __typename?: 'FashionCollection';
  id: Scalars['UUID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isFavourite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: Account;
  sections: Array<FashionCollectionSection>;
  teamContributors: Array<TeamContributor>;
  userAccess?: Maybe<UserAccess>;
  userContributors: Array<UserContributor>;
};

export type FashionCollectionEvent = Event & {
  __typename?: 'FashionCollectionEvent';
  collection: FashionCollection;
  type: EventType;
};

export type FashionCollectionEventUnion = EntityDeletedEvent | FashionCollectionEvent;

export enum FashionCollectionField {
  IsArchived = 'IS_ARCHIVED',
  Name = 'NAME',
  Owner = 'OWNER'
}

export type FashionCollectionFilterInput = {
  field: FashionCollectionField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type FashionCollectionItem = {
  __typename?: 'FashionCollectionItem';
  collections: Array<FashionCollection>;
  comments: Array<Comment>;
  commentsState: CommentsState;
  id: Scalars['UUID']['output'];
  labels: Array<FashionCollectionLabel>;
  name: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  projects: Array<Project>;
  resources: Array<Resource>;
  sku?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
  userAccess?: Maybe<UserAccess>;
};

export enum FashionCollectionItemField {
  Collections = 'COLLECTIONS',
  Labels = 'LABELS',
  Name = 'NAME',
  ProductId = 'PRODUCT_ID',
  Projects = 'PROJECTS'
}

export type FashionCollectionItemFilterInput = {
  field: FashionCollectionItemField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type FashionCollectionItemSorterInput = {
  direction: SortDirection;
  field: FashionCollectionItemField;
};

export type FashionCollectionItems = {
  __typename?: 'FashionCollectionItems';
  items: Array<FashionCollectionItem>;
  meta: Metadata;
};

export type FashionCollectionItemsSetFilterInput = {
  field: FashionCollectionItemField;
  filters?: Array<Array<FashionCollectionItemFilterInput>>;
};

export type FashionCollectionLabel = {
  __typename?: 'FashionCollectionLabel';
  color: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum FashionCollectionLabelField {
  Color = 'COLOR',
  IsActive = 'IS_ACTIVE',
  Name = 'NAME'
}

export type FashionCollectionLabelFilterInput = {
  field: FashionCollectionLabelField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type FashionCollectionLabelSorterInput = {
  direction: SortDirection;
  field: LabelField;
};

export type FashionCollectionLabels = {
  __typename?: 'FashionCollectionLabels';
  labels: Array<FashionCollectionLabel>;
  meta?: Maybe<Metadata>;
};

export type FashionCollectionSection = {
  __typename?: 'FashionCollectionSection';
  id: Scalars['UUID']['output'];
  items: Array<FashionCollectionItem>;
  name: Scalars['String']['output'];
};

export type FashionCollectionSorterInput = {
  direction: SortDirection;
  field: FashionCollectionField;
};

export type FashionCollections = {
  __typename?: 'FashionCollections';
  collections: Array<FashionCollection>;
  meta: Metadata;
};

export enum Feature {
  AdvancedProductionPlanning = 'ADVANCED_PRODUCTION_PLANNING',
  Bom = 'BOM',
  Email = 'EMAIL',
  FashionCollections = 'FASHION_COLLECTIONS',
  Orders = 'ORDERS',
  TimeTracking = 'TIME_TRACKING'
}

export enum FilterOperator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL'
}

export type FilterValue = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<TimestampInput>;
};

export type FirstCommentInput = {
  emailEnvelope: ExternalEmailEnvelopeInput;
  recipients: SaveRecipientsInput;
  resources?: Array<SaveResourceInput>;
  text: Scalars['String']['input'];
};

export type FloatValue = {
  __typename?: 'FloatValue';
  value: Scalars['Float']['output'];
};

export type GetBoardInput = {
  id: Scalars['UUID']['input'];
};

export type GetCategoriesForContextTypeInput = {
  contextType: ContextType;
  entityId: Scalars['UUID']['input'];
};

export type GetCategoryInput = {
  id: Scalars['UUID']['input'];
};

export type GetForRecurringInput = {
  filters?: InputMaybe<Array<TaskFilterInput>>;
  pageRequest?: InputMaybe<PageRequestInput>;
  recurringId: Scalars['UUID']['input'];
  sorters?: InputMaybe<Array<TaskSorterInput>>;
};

export type GetGoalInput = {
  id: Scalars['UUID']['input'];
};

export type GetInvitationInput = {
  id: Scalars['UUID']['input'];
};

export type GetInvitationsInput = {
  filters?: InputMaybe<Array<InvitationFilterInput>>;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<InvitationSorterInput>>;
};

export type GetLogEntriesInput = {
  entityId: Scalars['UUID']['input'];
  entityType: EntityType;
};

export type GetMilestoneDependenciesInput = {
  milestoneId: Scalars['UUID']['input'];
};

export type GetMilestoneInput = {
  milestoneId: Scalars['UUID']['input'];
};

export type GetMilestonesProjectCustomFieldSetFiltersInput = {
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<Array<MilestoneFilterInput>>>;
  includeServiceMilestones?: Scalars['Boolean']['input'];
  projectCustomFieldFilters?: Array<CustomFieldFilterInput>;
};

export type GetMilestonesSetFiltersInput = {
  field: MilestoneField;
  filters?: InputMaybe<Array<Array<MilestoneFilterInput>>>;
  includeServiceMilestones?: Scalars['Boolean']['input'];
  projectCustomFieldFilters?: Array<CustomFieldFilterInput>;
};

export type GetMyTasksSetFiltersInput = {
  additionalFilters: AdditionalTaskFiltersInput;
  field: TaskField;
  filters?: InputMaybe<Array<Array<TaskFilterInput>>>;
  isTodos?: Scalars['Boolean']['input'];
};

export type GetNotificationSetFiltersInput = {
  field: NotificationField;
  filters?: InputMaybe<Array<NotificationFilterInput>>;
};

export type GetProcedureInput = {
  id: Scalars['UUID']['input'];
};

export type GetProcedureMilestoneDependenciesInput = {
  procedureMilestoneId: Scalars['UUID']['input'];
};

export type GetProjectInput = {
  id: Scalars['UUID']['input'];
};

export type GetProjectMaterialSetFilterInput = {
  field: ProjectMaterialField;
  filters?: Array<SearchProjectMaterialFilterInput>;
};

export type GetProjectsCustomFieldSetFiltersInput = {
  customFieldFilters?: Array<CustomFieldFilterInput>;
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<Array<ProjectFilterInput>>>;
};

export type GetProjectsQuantityInput = {
  customFieldFilters?: Array<CustomFieldFilterInput>;
  filters?: InputMaybe<Array<Array<ProjectFilterInput>>>;
};

export type GetProjectsSetFiltersInput = {
  customFieldFilters?: Array<CustomFieldFilterInput>;
  field: ProjectField;
  filters?: InputMaybe<Array<Array<ProjectFilterInput>>>;
};

export type GetResourceInput = {
  id: Scalars['UUID']['input'];
};

export type GetResourcePolicyInput = {
  filename: Scalars['String']['input'];
};

export type GetResourceSetFiltersInput = {
  field: ResourceField;
  filters?: InputMaybe<Array<Array<ResourceFilterInput>>>;
};

export type GetTaskInput = {
  id: Scalars['UUID']['input'];
};

export type GetTeamInput = {
  id: Scalars['UUID']['input'];
};

export type GetTeamsByAccountIdInput = {
  accountId: Scalars['UUID']['input'];
};

export type Goal = {
  __typename?: 'Goal';
  assignee?: Maybe<Account>;
  boards: Array<Board>;
  comments: Array<Comment>;
  commentsState?: Maybe<CommentsState>;
  createdAt: Timestamp;
  createdBy: Account;
  deadline?: Maybe<Timestamp>;
  delay?: Maybe<Scalars['Int']['output']>;
  executionDate?: Maybe<Timestamp>;
  followers: Array<Account>;
  goalTree: Array<Goal>;
  id: Scalars['UUID']['output'];
  labels: Array<Label>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  owner: Account;
  parentId?: Maybe<Scalars['UUID']['output']>;
  projects: Array<Project>;
  remindMe?: Maybe<Timestamp>;
  resources: Array<Resource>;
  resourcesForGoalTree: Array<Resource>;
  rootId: Scalars['UUID']['output'];
  sections: Array<Section>;
  status: Status;
  tasks: Array<Task>;
  teamFollowers: Array<Team>;
  userAccess?: Maybe<UserAccess>;
};


export type GoalTasksArgs = {
  excludeCanceled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoalEvent = Event & {
  __typename?: 'GoalEvent';
  goal: Goal;
  type: EventType;
};

export type GoalEventUnion = EntityDeletedEvent | GoalEvent;

export enum GoalField {
  Assignee = 'ASSIGNEE',
  Board = 'BOARD',
  Deadline = 'DEADLINE',
  ExecutionDate = 'EXECUTION_DATE',
  Label = 'LABEL',
  Name = 'NAME',
  Notes = 'NOTES',
  Owner = 'OWNER',
  Status = 'STATUS'
}

export type GoalFilterInput = {
  field: GoalField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type GoalFollowerActionInput = {
  followerId: Scalars['UUID']['input'];
  goalId: Scalars['UUID']['input'];
};

export type GoalSectionInput = {
  goalId: Scalars['UUID']['input'];
  sectionId: Scalars['UUID']['input'];
};

export type GoalSorterInput = {
  direction: SortDirection;
  field: GoalField;
};

export type Goals = {
  __typename?: 'Goals';
  goals: Array<Goal>;
  meta: Metadata;
};

export type GoalsSetFilterInput = {
  field: GoalField;
  filters?: Array<Array<GoalFilterInput>>;
};

export type ImapSettings = {
  __typename?: 'ImapSettings';
  imapHost: Scalars['String']['output'];
  imapPassword: Scalars['String']['output'];
  imapPort: Scalars['Int']['output'];
  smtpHost: Scalars['String']['output'];
  smtpPort: Scalars['Int']['output'];
};

export type IntValue = {
  __typename?: 'IntValue';
  value: Scalars['Int']['output'];
};

export type InternalUsageReportInput = {
  from: TimestampInput;
  organizationId: Scalars['UUID']['input'];
  to: TimestampInput;
};

export type InternalUsageReportRow = BaseUsageReportRow & {
  __typename?: 'InternalUsageReportRow';
  account: Account;
  addedMilestoneReminders?: Maybe<Scalars['Int']['output']>;
  assignedGoals?: Maybe<Scalars['Int']['output']>;
  assignedTasks?: Maybe<Scalars['Int']['output']>;
  assignedTodos?: Maybe<Scalars['Int']['output']>;
  commentsInGoals?: Maybe<Scalars['Int']['output']>;
  commentsInTasks?: Maybe<Scalars['Int']['output']>;
  commentsInThreads?: Maybe<Scalars['Int']['output']>;
  commentsInTodos?: Maybe<Scalars['Int']['output']>;
  completedGoals?: Maybe<Scalars['Int']['output']>;
  completedMilestones?: Maybe<Scalars['Int']['output']>;
  completedTasks?: Maybe<Scalars['Int']['output']>;
  completedTodos?: Maybe<Scalars['Int']['output']>;
  convertedThreadsToGoals?: Maybe<Scalars['Int']['output']>;
  convertedThreadsToTodos?: Maybe<Scalars['Int']['output']>;
  createdGoals?: Maybe<Scalars['Int']['output']>;
  createdSubGoals?: Maybe<Scalars['Int']['output']>;
  createdTasks?: Maybe<Scalars['Int']['output']>;
  createdThreads?: Maybe<Scalars['Int']['output']>;
  createdTodos?: Maybe<Scalars['Int']['output']>;
  deadlineChangeRequests?: Maybe<Scalars['Int']['output']>;
  receivedNotifications?: Maybe<Scalars['Int']['output']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Timestamp;
  expiresAt: Timestamp;
  havelockEnabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  inviteeEmail: Scalars['String']['output'];
  inviter: Account;
  prodactiveEnabled: Scalars['Boolean']['output'];
  roles: Array<Role>;
  status: InvitationStatus;
};

export enum InvitationField {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Email = 'EMAIL',
  ExpiresAt = 'EXPIRES_AT',
  Roles = 'ROLES',
  Status = 'STATUS'
}

export type InvitationFilterInput = {
  field: InvitationField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type InvitationSetFilterInput = {
  field: InvitationField;
  filters?: InputMaybe<Array<InvitationFilterInput>>;
};

export type InvitationSorterInput = {
  direction: SortDirection;
  field: InvitationField;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type Invitations = {
  __typename?: 'Invitations';
  invitations: Array<Invitation>;
  meta: Metadata;
};

export type Job = {
  __typename?: 'Job';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  status: Status;
};

export type JobTitle = {
  __typename?: 'JobTitle';
  application: Application;
  id: Scalars['UUID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type JobTitles = {
  __typename?: 'JobTitles';
  jobTitlesList?: Maybe<Array<JobTitle>>;
  meta: Metadata;
};

export type KeyMilestonesSettings = MilestoneSettings & {
  __typename?: 'KeyMilestonesSettings';
  projectTypes: Array<ProjectType>;
  timeFactors: Array<TimeFactor>;
  trackedActivities: Array<TrackedActivity>;
};

export type Label = {
  __typename?: 'Label';
  color: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum LabelField {
  Color = 'COLOR',
  IsActive = 'IS_ACTIVE',
  Name = 'NAME'
}

export type LabelsResponse = {
  __typename?: 'LabelsResponse';
  labels?: Maybe<Array<Label>>;
  meta?: Maybe<Metadata>;
};

export enum Language {
  Bg = 'BG',
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR'
}

export type LikeDetails = {
  __typename?: 'LikeDetails';
  isLikedByUser: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
};

export type LinkEntityToEmailInput = {
  entityId: Scalars['UUID']['input'];
  entityType: EmailLinkableEntityType;
  link: LinkEntityToEmailLinkInput;
};

export type LinkEntityToEmailLinkInput = {
  comment: FirstCommentInput;
  messageId: EmailMessageIdInput;
  shouldPostReplies: Scalars['Boolean']['input'];
};

export type LoadProcedureInput = {
  deselectedMilestones?: InputMaybe<Array<Scalars['UUID']['input']>>;
  deselectedTasks?: InputMaybe<Array<Scalars['UUID']['input']>>;
  procedureId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
  shouldSaveTasks?: Scalars['Boolean']['input'];
};

export type LoadProcedureMilestoneInProcedureInput = {
  procedureId: Scalars['UUID']['input'];
  procedureMilestoneIds: Array<Scalars['UUID']['input']>;
};

export type LogEntry = {
  __typename?: 'LogEntry';
  changeType: ChangeType;
  createdAt: Timestamp;
  createdBy: Account;
  entityId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isCreate: Scalars['Boolean']['output'];
  newValue?: Maybe<LogEntryValue>;
  oldValue?: Maybe<LogEntryValue>;
};

export type LogEntryValue = FloatValue | IntValue | LogEntryValueAccounts | LogEntryValueLabels | StringValue | TaskDeletedLogEntry | Timestamp;

export type LogEntryValueAccounts = {
  __typename?: 'LogEntryValueAccounts';
  value: Array<Account>;
};

export type LogEntryValueLabels = {
  __typename?: 'LogEntryValueLabels';
  value: Array<Label>;
};

export type LoggedTime = {
  __typename?: 'LoggedTime';
  hours: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  time: Timestamp;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  contactDetails: ContactDetails;
  contacts: Array<Contact>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Manufacturers = {
  __typename?: 'Manufacturers';
  manufacturers: Array<Manufacturer>;
  meta: Metadata;
};

export type MarkCommentReadInput = {
  id: Scalars['UUID']['input'];
  isRead: Scalars['Boolean']['input'];
};

export type Material = {
  __typename?: 'Material';
  colour?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Resource>;
  inventories: Array<MaterialInventory>;
  isInProduction: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  leadTime?: Maybe<Scalars['Int']['output']>;
  manufacturer: Manufacturer;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  priceCurrency?: Maybe<Currency>;
  referenceNumber: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  type: MaterialType;
};

export enum MaterialField {
  Colour = 'COLOUR',
  Content = 'CONTENT',
  IsInProduction = 'IS_IN_PRODUCTION',
  IsProcessing = 'IS_PROCESSING',
  LeadTime = 'LEAD_TIME',
  Manufacturer = 'MANUFACTURER',
  Name = 'NAME',
  ReferenceNumber = 'REFERENCE_NUMBER',
  Size = 'SIZE'
}

export type MaterialFilterInput = {
  field: MaterialField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type MaterialInventory = {
  __typename?: 'MaterialInventory';
  client?: Maybe<Client>;
  project?: Maybe<Project>;
  quantity: Scalars['Int']['output'];
  warehouse: Warehouse;
};

export type MaterialQuantity = {
  __typename?: 'MaterialQuantity';
  material: Material;
  quantity: Scalars['Int']['output'];
};

export type MaterialSorterInput = {
  direction: SortDirection;
  field: MaterialField;
};

export type MaterialType = {
  __typename?: 'MaterialType';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type MaterialTypes = {
  __typename?: 'MaterialTypes';
  materialTypes: Array<MaterialType>;
  meta: Metadata;
};

export type Materials = {
  __typename?: 'Materials';
  materials: Array<Material>;
  meta: Metadata;
};

export type MaterialsProductionRequest = {
  __typename?: 'MaterialsProductionRequest';
  id: Scalars['UUID']['output'];
  items: Array<MaterialsProductionRequestItem>;
  materialQuantities: Array<MaterialQuantity>;
  number: Scalars['Int']['output'];
  owner: Account;
  productionNotes?: Maybe<Scalars['String']['output']>;
  reminder: Timestamp;
  sizeMatrices: Array<SizeMatrix>;
  status: MaterialsProductionRequestStatus;
  stockRequests: Array<StockRequest>;
  warehouseNotes?: Maybe<Scalars['String']['output']>;
};

export enum MaterialsProductionRequestField {
  Number = 'NUMBER',
  Owner = 'OWNER',
  ProductionNotes = 'PRODUCTION_NOTES',
  Project = 'PROJECT',
  Reminder = 'REMINDER',
  SizeMatrix = 'SIZE_MATRIX',
  Status = 'STATUS',
  WarehouseNotes = 'WAREHOUSE_NOTES'
}

export type MaterialsProductionRequestFilterInput = {
  field: MaterialsProductionRequestField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type MaterialsProductionRequestItem = {
  __typename?: 'MaterialsProductionRequestItem';
  quantity: Scalars['Int']['output'];
  requestedQuantity: Scalars['Int']['output'];
  sizeMatrixItem: SizeMatrixItem;
};

export type MaterialsProductionRequestItemInput = {
  quantity: Scalars['Int']['input'];
  sizeMatrixItemId: Scalars['UUID']['input'];
};

export type MaterialsProductionRequestSorterInput = {
  direction: SortDirection;
  field: MaterialsProductionRequestField;
};

export enum MaterialsProductionRequestStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type MaterialsProductionRequests = {
  __typename?: 'MaterialsProductionRequests';
  materialsProductionRequests: Array<MaterialsProductionRequest>;
  meta: Metadata;
};

export type MaterialsProductionRequestsSetFilterInput = {
  field: MaterialsProductionRequestField;
  filters?: Array<MaterialsProductionRequestFilterInput>;
};

export type MaterialsSetFilterInput = {
  field: MaterialField;
  filters?: Array<MaterialFilterInput>;
};

export type MemberGoals = {
  __typename?: 'MemberGoals';
  activeGoals: Scalars['Int']['output'];
  completedGoals: Scalars['Int']['output'];
};

export type MemberTasks = {
  __typename?: 'MemberTasks';
  activeTasks: Scalars['Int']['output'];
  completedTasks: Scalars['Int']['output'];
};

export type Metadata = {
  __typename?: 'Metadata';
  pagination: Pagination;
};

export type Milestone = {
  __typename?: 'Milestone';
  adjustedDuration: Scalars['Int']['output'];
  allowedStatuses: Array<Status>;
  baseId?: Maybe<Scalars['UUID']['output']>;
  delay?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Int']['output'];
  dynamicPlanner?: Maybe<Timestamp>;
  executionDate?: Maybe<Timestamp>;
  id: Scalars['UUID']['output'];
  isAfterProjectEnd: Scalars['Boolean']['output'];
  isCheckpoint: Scalars['Boolean']['output'];
  isDeadlineLocked: Scalars['Boolean']['output'];
  isService: Scalars['Boolean']['output'];
  label?: Maybe<Label>;
  milestoneDependencyIds: Array<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  project: Project;
  projectedDeadline?: Maybe<Timestamp>;
  resources: Array<Resource>;
  status: Status;
  targetDeadline?: Maybe<Timestamp>;
  tasks?: Maybe<Array<Task>>;
  tasksMeta?: Maybe<TasksMetadata>;
};


export type MilestoneTasksArgs = {
  excludeCanceled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MilestoneDateFilterInput = {
  baseMilestoneId: Scalars['UUID']['input'];
  period: PeriodInput;
};

export type MilestoneDeadline = {
  __typename?: 'MilestoneDeadline';
  milestoneId: Scalars['UUID']['output'];
  targetDeadline: Timestamp;
};

export type MilestoneDeadlineInput = {
  isAfterProjectEnd: Scalars['Boolean']['input'];
  milestoneId: Scalars['UUID']['input'];
  targetDeadline: TimestampInput;
};

export type MilestoneDeadlinesInput = {
  areCalculatedFromStart: Scalars['Boolean']['input'];
  deadlines: Array<MilestoneDeadlineInput>;
  projectDate?: InputMaybe<TimestampInput>;
};

export type MilestoneDependencies = {
  __typename?: 'MilestoneDependencies';
  milestoneDependencyIds: Array<Scalars['UUID']['output']>;
  milestones: Array<Milestone>;
  name: Scalars['String']['output'];
  projectId: Scalars['UUID']['output'];
};

export type MilestoneEvent = Event & {
  __typename?: 'MilestoneEvent';
  milestone: Milestone;
  type: EventType;
};

export type MilestoneEventUnion = EntityDeletedEvent | MilestoneEvent;

export enum MilestoneField {
  DynamicPlanner = 'DYNAMIC_PLANNER',
  Name = 'NAME',
  Notes = 'NOTES',
  ProjectClients = 'PROJECT_CLIENTS',
  ProjectDeadline = 'PROJECT_DEADLINE',
  ProjectDelay = 'PROJECT_DELAY',
  ProjectExecutionDate = 'PROJECT_EXECUTION_DATE',
  ProjectGoals = 'PROJECT_GOALS',
  ProjectHasPriority = 'PROJECT_HAS_PRIORITY',
  ProjectName = 'PROJECT_NAME',
  ProjectNotes = 'PROJECT_NOTES',
  ProjectProducers = 'PROJECT_PRODUCERS',
  ProjectQuantity = 'PROJECT_QUANTITY',
  ProjectReference = 'PROJECT_REFERENCE',
  ProjectResponsible = 'PROJECT_RESPONSIBLE',
  ProjectStartDate = 'PROJECT_START_DATE',
  ProjectStatus = 'PROJECT_STATUS',
  ProjectTimeFactor = 'PROJECT_TIME_FACTOR',
  ProjectType = 'PROJECT_TYPE',
  Status = 'STATUS',
  TargetDeadline = 'TARGET_DEADLINE'
}

export type MilestoneFilterInput = {
  field: MilestoneField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type MilestoneSettings = {
  projectTypes: Array<ProjectType>;
  timeFactors: Array<TimeFactor>;
  trackedActivities: Array<TrackedActivity>;
};

export type MilestoneSorterInput = {
  direction: SortDirection;
  field: MilestoneField;
};

export type Milestones = {
  __typename?: 'Milestones';
  meta: Metadata;
  milestones: Array<Milestone>;
};

export type MilestonesSettingsInput = {
  isClientsColumnEnabled?: Scalars['Boolean']['input'];
  isDeadlineColumnEnabled?: Scalars['Boolean']['input'];
  isProvidersColumnEnabled?: Scalars['Boolean']['input'];
  isQuantityColumnEnabled?: Scalars['Boolean']['input'];
  isResponsibleColumnEnabled?: Scalars['Boolean']['input'];
  isTimeFactorColumnEnabled?: Scalars['Boolean']['input'];
  isTypeColumnEnabled?: Scalars['Boolean']['input'];
  projectTypeIds?: Array<Scalars['UUID']['input']>;
  timeFactorIds?: Array<Scalars['UUID']['input']>;
  trackedActivities: Array<TrackedActivityInput>;
};

export type ModifyResourceInput = {
  saveResourceInput?: InputMaybe<SaveResourceInput>;
  updateResourceInput?: InputMaybe<UpdateResourceInput>;
};

export type MoveGoalToSectionInput = {
  afterGoalId?: InputMaybe<Scalars['UUID']['input']>;
  fromSectionId: Scalars['UUID']['input'];
  goalId: Scalars['UUID']['input'];
  toSectionId: Scalars['UUID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: EmptyResponse;
  activateStandbyTask: Array<Task>;
  addFashionCollectionItemToSection: EmptyResponse;
  addGoalToSection: EmptyResponse;
  addPermissionToRole?: Maybe<EmptyResponse>;
  addProcedureMilestone?: Maybe<ProcedureMilestone>;
  addProcedureTask: ProcedureTask;
  addPushNotificationDevice: EmptyResponse;
  adjustMaterials: Transaction;
  applyMilestoneDeadlines?: Maybe<EmptyResponse>;
  assignProducer: AssignedProducer;
  authorizeGoogleEmailAccount?: Maybe<EmptyResponse>;
  batchUpdateMilestone: Array<Milestone>;
  changeAssignee: Array<Task>;
  changeCommentReadStatus: EmptyResponse;
  checkinMaterials: Transaction;
  checkoutMaterials: Transaction;
  convertThreadToGoal: Goal;
  convertThreadToTask: Task;
  copyProcedure?: Maybe<EmptyResponse>;
  copyProjectMaterials: EmptyResponse;
  createNextTaskByRecurringDefinition: Array<Task>;
  createOrganization: EmptyResponse;
  createSignature: Scalars['UUID']['output'];
  deleteAddress: EmptyResponse;
  deleteAssignedProducer: EmptyResponse;
  deleteBoard: EmptyResponse;
  deleteCommentReminder: EmptyResponse;
  deleteContacts?: Maybe<EmptyResponse>;
  deleteCustomFieldDefinition?: Maybe<EmptyResponse>;
  deleteEmailAccount?: Maybe<EmptyResponse>;
  deleteFashionCollection: EmptyResponse;
  deleteFashionCollectionItem: EmptyResponse;
  deleteFashionCollectionLabel?: Maybe<EmptyResponse>;
  deleteFashionCollectionSection: EmptyResponse;
  deleteGoal: EmptyResponse;
  deleteInvitation: EmptyResponse;
  deleteLabel?: Maybe<EmptyResponse>;
  deleteLoggedTime?: Maybe<EmptyResponse>;
  deleteMaterial: EmptyResponse;
  deleteMilestone?: Maybe<EmptyResponse>;
  deleteOrganization: EmptyResponse;
  deletePermission?: Maybe<EmptyResponse>;
  deleteProcedure?: Maybe<EmptyResponse>;
  deleteProcedureMilestones?: Maybe<EmptyResponse>;
  deleteProcedureTasks: EmptyResponse;
  deleteProjectMaterial: EmptyResponse;
  deleteResources?: Maybe<DeleteResource>;
  deleteRole?: Maybe<EmptyResponse>;
  deleteSection: EmptyResponse;
  deleteSignature?: Maybe<EmptyResponse>;
  deleteSizeMatrix: EmptyResponse;
  deleteSizes?: Maybe<EmptyResponse>;
  deleteStandbyTask: EmptyResponse;
  deleteTranslation: EmptyResponse;
  deleteWorkCalendarExceptionPeriod: EmptyResponse;
  discardThreadDraft?: Maybe<EmptyResponse>;
  editAssignees: Array<Task>;
  favouriteFashionCollection?: Maybe<EmptyResponse>;
  goalFollowerAction: Goal;
  importProjects: Job;
  linkEntityToEmail: Scalars['UUID']['output'];
  loadProcedure: Array<Milestone>;
  loadProcedureMilestonesInProcedure?: Maybe<EmptyResponse>;
  markGoalCommentsRead?: Maybe<EmptyResponse>;
  markProjectMaterialsFullyOrdered: EmptyResponse;
  markProjectMaterialsFullyReserved: EmptyResponse;
  markTaskCommentsRead?: Maybe<EmptyResponse>;
  moveGoalToSection: EmptyResponse;
  optimizeMilestonesSchedule: Array<Milestone>;
  positionCustomFieldDefinition?: Maybe<EmptyResponse>;
  positionFashionCollectionItem: EmptyResponse;
  positionProcedureMilestone?: Maybe<EmptyResponse>;
  positionProcedureTask?: Maybe<EmptyResponse>;
  positionProjectMaterial: EmptyResponse;
  positionTask?: Maybe<EmptyResponse>;
  recurringDefinitionFollowerAction: RecurringTaskDefinition;
  removeGoalFromSection: EmptyResponse;
  removePermissionFromRole?: Maybe<EmptyResponse>;
  removeTaskReminder?: Maybe<EmptyResponse>;
  resendInvitation: Invitation;
  reserveMaterials: Transaction;
  saveAddress: Address;
  saveBaseMilestone?: Maybe<BaseMilestone>;
  saveBoard: Board;
  saveCategory?: Maybe<Category>;
  saveClient: Client;
  saveComment: SaveCommentResponse;
  saveCommentReminder: Comment;
  saveContact?: Maybe<Contact>;
  saveCustomFieldDefinition: CustomFieldDefinition;
  saveFashionCollection: FashionCollection;
  saveFashionCollectionItem: FashionCollectionItem;
  saveFashionCollectionLabel?: Maybe<FashionCollectionLabel>;
  saveFashionCollectionSection: FashionCollectionSection;
  saveGoal: Goal;
  saveGoogleEmailAccount: SaveAccountResponse;
  saveImapAccount: SaveAccountResponse;
  saveJobTitle?: Maybe<JobTitle>;
  saveLabel?: Maybe<Label>;
  saveLoggedTime: LoggedTime;
  saveManufacturer: Manufacturer;
  saveMaterial: Material;
  saveMaterialType: MaterialType;
  saveMaterialsProductionRequest: MaterialsProductionRequest;
  saveMilestone?: Maybe<Milestone>;
  saveMilestoneDependencies?: Maybe<EmptyResponse>;
  saveOrder: Order;
  saveOutlookAccount: SaveAccountResponse;
  savePermission?: Maybe<EmptyResponse>;
  saveProcedure?: Maybe<Procedure>;
  saveProcedureFromProject?: Maybe<EmptyResponse>;
  saveProcedureMilestoneDependencies?: Maybe<EmptyResponse>;
  saveProducer: Producer;
  saveProducerTracking: ProducerTracking;
  saveProject?: Maybe<Project>;
  saveProjectMaterial: ProjectMaterial;
  saveProjectType?: Maybe<ProjectType>;
  saveRecurringDefinition?: Maybe<RecurringTaskDefinition>;
  saveResources: Array<Resource>;
  saveRole?: Maybe<EmptyResponse>;
  saveSection: Section;
  saveSize: Size;
  saveSizeMatrix: SizeMatrix;
  saveSizeStandard: SizeStandard;
  saveStockRequests: Array<StockRequest>;
  saveSubTask: Array<Task>;
  saveSupplier: Supplier;
  saveTask: Array<Task>;
  saveTaskReminder?: Maybe<EmptyResponse>;
  saveTeam: Team;
  saveThread: Thread;
  saveThreadDraft: ThreadDraft;
  saveTimeFactor?: Maybe<TimeFactor>;
  saveTranslationNote: EmptyResponse;
  saveTranslations: EmptyResponse;
  saveWarehouse: Warehouse;
  saveWorkCalendarExceptionPeriod: WorkCalendarExceptionPeriod;
  sendInvitation: Invitation;
  setAccountActive: EmptyResponse;
  setAllNotificationsRead: EmptyResponse;
  setKeyMilestoneReminder: EmptyResponse;
  setNotificationRead: EmptyResponse;
  setProductionPlanningReminder: EmptyResponse;
  setProjectMaterialsDeadline: EmptyResponse;
  taskFollowerAction?: Maybe<Task>;
  toggleCommentLike: EmptyResponse;
  toggleProjectFavourite?: Maybe<EmptyResponse>;
  toggleThreadFavourite?: Maybe<EmptyResponse>;
  transferMaterials: Transaction;
  transformStandbyToRecurring: RecurringTaskDefinition;
  unfavouriteFashionCollection?: Maybe<EmptyResponse>;
  unlinkEntityFromEmail?: Maybe<EmptyResponse>;
  unreserveMaterials: Transaction;
  updateAccount?: Maybe<Account>;
  updateAddress: Address;
  updateAssignedProducer: AssignedProducer;
  updateBaseMilestone?: Maybe<BaseMilestone>;
  updateBoard: Board;
  updateBoardUserSettings: EmptyResponse;
  updateCategory?: Maybe<Category>;
  updateClient: Client;
  updateComment: Comment;
  updateContact?: Maybe<Contact>;
  updateCustomFieldDefinition: CustomFieldDefinition;
  updateEmailAccount?: Maybe<EmptyResponse>;
  updateEmailLinkedEntity?: Maybe<EmptyResponse>;
  updateFashionCollection: FashionCollection;
  updateFashionCollectionItem: FashionCollectionItem;
  updateFashionCollectionLabel?: Maybe<FashionCollectionLabel>;
  updateFashionCollectionSection: FashionCollectionSection;
  updateGoal: Goal;
  updateImapAccount?: Maybe<ErrorResponse>;
  updateJobTitle?: Maybe<JobTitle>;
  updateLabel?: Maybe<Label>;
  updateLoggedTime: LoggedTime;
  updateManufacturer: Manufacturer;
  updateMaterial: Material;
  updateMaterialType: MaterialType;
  updateMaterialsProductionRequest: MaterialsProductionRequest;
  updateMilestone: Milestone;
  updateOrder: Order;
  updateOrganization: Organization;
  updateOrganizationInternal: Organization;
  updateProcedure?: Maybe<Procedure>;
  updateProcedureMilestone?: Maybe<ProcedureMilestone>;
  updateProcedureTask: ProcedureTask;
  updateProducer: Producer;
  updateProject?: Maybe<Project>;
  updateProjectMaterial: ProjectMaterial;
  updateProjectMaterialsOwner: EmptyResponse;
  updateProjectType?: Maybe<ProjectType>;
  updateRecurringDefinition?: Maybe<RecurringTaskDefinition>;
  updateResource?: Maybe<Resource>;
  updateSection: Section;
  updateSignature?: Maybe<EmptyResponse>;
  updateSize: Size;
  updateSizeMatrix: SizeMatrix;
  updateSizeStandard: SizeStandard;
  updateSupplier: Supplier;
  updateTask: Array<Task>;
  updateTeam: Team;
  updateThread?: Maybe<EmptyResponse>;
  updateThreadDraft: ThreadDraft;
  updateTimeFactor?: Maybe<TimeFactor>;
  updateWarehouse: Warehouse;
  updateWorkCalendarExceptionPeriod: WorkCalendarExceptionPeriod;
};


export type MutationAcceptInvitationArgs = {
  input?: InputMaybe<AcceptInvitationInput>;
};


export type MutationActivateStandbyTaskArgs = {
  input: ActivateStandbyTaskInput;
};


export type MutationAddFashionCollectionItemToSectionArgs = {
  input: AddFashionCollectionToSectionInput;
};


export type MutationAddGoalToSectionArgs = {
  input: GoalSectionInput;
};


export type MutationAddPermissionToRoleArgs = {
  application: Application;
  permissionName: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
};


export type MutationAddProcedureMilestoneArgs = {
  input: AddProcedureMilestoneInput;
};


export type MutationAddProcedureTaskArgs = {
  input: AddProcedureTaskInput;
};


export type MutationAddPushNotificationDeviceArgs = {
  token: Scalars['String']['input'];
};


export type MutationAdjustMaterialsArgs = {
  input: AdjustMaterialsInput;
};


export type MutationApplyMilestoneDeadlinesArgs = {
  input: MilestoneDeadlinesInput;
};


export type MutationAssignProducerArgs = {
  input: AssignProducerInput;
};


export type MutationAuthorizeGoogleEmailAccountArgs = {
  authorizationCode: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationBatchUpdateMilestoneArgs = {
  inputs: Array<UpdateMilestoneInput>;
};


export type MutationChangeAssigneeArgs = {
  input?: InputMaybe<ReplaceTaskAssigneeInput>;
};


export type MutationChangeCommentReadStatusArgs = {
  input?: InputMaybe<MarkCommentReadInput>;
};


export type MutationCheckinMaterialsArgs = {
  input: AdjustMaterialsInput;
};


export type MutationCheckoutMaterialsArgs = {
  input: AdjustMaterialsInput;
};


export type MutationConvertThreadToGoalArgs = {
  input: ConvertThreadToGoalInput;
};


export type MutationConvertThreadToTaskArgs = {
  input: ConvertThreadToTaskInput;
};


export type MutationCopyProcedureArgs = {
  input: CopyProcedureInput;
};


export type MutationCopyProjectMaterialsArgs = {
  input: CopyProjectMaterialsInput;
};


export type MutationCreateNextTaskByRecurringDefinitionArgs = {
  input?: InputMaybe<RecurringDefinitionIdInput>;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateSignatureArgs = {
  input: CreateSignatureInput;
};


export type MutationDeleteAddressArgs = {
  addressId: Scalars['UUID']['input'];
};


export type MutationDeleteAssignedProducerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteBoardArgs = {
  input: GetBoardInput;
};


export type MutationDeleteCommentReminderArgs = {
  input: DeleteCommentReminderInput;
};


export type MutationDeleteContactsArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteCustomFieldDefinitionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteEmailAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFashionCollectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFashionCollectionItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFashionCollectionLabelArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFashionCollectionSectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteGoalArgs = {
  input: GetGoalInput;
};


export type MutationDeleteInvitationArgs = {
  input?: InputMaybe<DeleteInvitationInput>;
};


export type MutationDeleteLabelArgs = {
  input?: InputMaybe<DeleteLabelInput>;
};


export type MutationDeleteLoggedTimeArgs = {
  input?: InputMaybe<DeleteLoggedTimeInput>;
};


export type MutationDeleteMaterialArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteMilestoneArgs = {
  input: DeleteMilestoneInput;
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeletePermissionArgs = {
  application: Application;
  name: Scalars['String']['input'];
};


export type MutationDeleteProcedureArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteProcedureMilestonesArgs = {
  input: DeleteProcedureMilestoneInput;
};


export type MutationDeleteProcedureTasksArgs = {
  input: DeleteProcedureTasksInput;
};


export type MutationDeleteProjectMaterialArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteResourcesArgs = {
  input?: InputMaybe<DeleteResourcesInput>;
};


export type MutationDeleteRoleArgs = {
  application: Application;
  name: Scalars['String']['input'];
};


export type MutationDeleteSectionArgs = {
  input: DeleteSectionInput;
};


export type MutationDeleteSignatureArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSizeMatrixArgs = {
  input: DeleteSizeMatrixInput;
};


export type MutationDeleteSizesArgs = {
  input: DeleteSizeInput;
};


export type MutationDeleteStandbyTaskArgs = {
  input: GetTaskInput;
};


export type MutationDeleteTranslationArgs = {
  input: DeleteTranslationInput;
};


export type MutationDeleteWorkCalendarExceptionPeriodArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDiscardThreadDraftArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationEditAssigneesArgs = {
  input?: InputMaybe<EditTasksAssigneesInput>;
};


export type MutationFavouriteFashionCollectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGoalFollowerActionArgs = {
  input: GoalFollowerActionInput;
};


export type MutationImportProjectsArgs = {
  goalId?: InputMaybe<Scalars['UUID']['input']>;
  resource: SaveResourceInput;
};


export type MutationLinkEntityToEmailArgs = {
  input: LinkEntityToEmailInput;
};


export type MutationLoadProcedureArgs = {
  input: LoadProcedureInput;
};


export type MutationLoadProcedureMilestonesInProcedureArgs = {
  input: LoadProcedureMilestoneInProcedureInput;
};


export type MutationMarkGoalCommentsReadArgs = {
  id: Scalars['UUID']['input'];
  readAt: TimestampInput;
};


export type MutationMarkProjectMaterialsFullyOrderedArgs = {
  isOrdered?: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationMarkProjectMaterialsFullyReservedArgs = {
  isReserved?: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationMarkTaskCommentsReadArgs = {
  id: Scalars['UUID']['input'];
  readAt: TimestampInput;
};


export type MutationMoveGoalToSectionArgs = {
  input: MoveGoalToSectionInput;
};


export type MutationOptimizeMilestonesScheduleArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationPositionCustomFieldDefinitionArgs = {
  input: PositionCustomFieldDefinitionInput;
};


export type MutationPositionFashionCollectionItemArgs = {
  input: PositionFashionCollectionInput;
};


export type MutationPositionProcedureMilestoneArgs = {
  input: PositionProcedureMilestoneInput;
};


export type MutationPositionProcedureTaskArgs = {
  input: PositionProcedureTaskInput;
};


export type MutationPositionProjectMaterialArgs = {
  input: PositionProjectMaterialInput;
};


export type MutationPositionTaskArgs = {
  input?: InputMaybe<PositionTaskInput>;
};


export type MutationRecurringDefinitionFollowerActionArgs = {
  input: RecurringDefinitionIdInput;
};


export type MutationRemoveGoalFromSectionArgs = {
  input: GoalSectionInput;
};


export type MutationRemovePermissionFromRoleArgs = {
  application: Application;
  permissionName: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
};


export type MutationRemoveTaskReminderArgs = {
  input?: InputMaybe<RemoveTaskReminderInput>;
};


export type MutationResendInvitationArgs = {
  input?: InputMaybe<ResendInvitationInput>;
};


export type MutationReserveMaterialsArgs = {
  input: ReserveMaterialInput;
};


export type MutationSaveAddressArgs = {
  input: SaveAddressInput;
};


export type MutationSaveBaseMilestoneArgs = {
  input: SaveBaseMilestoneInput;
};


export type MutationSaveBoardArgs = {
  input: SaveBoardInput;
};


export type MutationSaveCategoryArgs = {
  input?: InputMaybe<SaveCategoryInput>;
};


export type MutationSaveClientArgs = {
  input: SaveClientInput;
};


export type MutationSaveCommentArgs = {
  input: SaveCommentInput;
};


export type MutationSaveCommentReminderArgs = {
  input: SaveCommentReminderInput;
};


export type MutationSaveContactArgs = {
  input: SaveContactInput;
};


export type MutationSaveCustomFieldDefinitionArgs = {
  input: SaveCustomFieldDefinitionInput;
};


export type MutationSaveFashionCollectionArgs = {
  input: SaveFashionCollectionInput;
};


export type MutationSaveFashionCollectionItemArgs = {
  input: SaveFashionCollectionItemInput;
};


export type MutationSaveFashionCollectionLabelArgs = {
  input?: InputMaybe<SaveFashionCollectionLabelInput>;
};


export type MutationSaveFashionCollectionSectionArgs = {
  input: SaveFashionCollectionSectionInput;
};


export type MutationSaveGoalArgs = {
  input: SaveGoalInput;
};


export type MutationSaveGoogleEmailAccountArgs = {
  input: SaveGoogleEmailAccountInput;
};


export type MutationSaveImapAccountArgs = {
  input: SaveImapAccountInput;
};


export type MutationSaveJobTitleArgs = {
  input?: InputMaybe<SaveJobTitleInput>;
};


export type MutationSaveLabelArgs = {
  input?: InputMaybe<SaveLabelInput>;
};


export type MutationSaveLoggedTimeArgs = {
  input?: InputMaybe<SaveLoggedTimeInput>;
};


export type MutationSaveManufacturerArgs = {
  input: SaveManufacturerInput;
};


export type MutationSaveMaterialArgs = {
  input: SaveMaterialInput;
};


export type MutationSaveMaterialTypeArgs = {
  input: SaveMaterialTypeInput;
};


export type MutationSaveMaterialsProductionRequestArgs = {
  input: SaveMaterialsProductionRequestInput;
};


export type MutationSaveMilestoneArgs = {
  input: SaveMilestoneInput;
};


export type MutationSaveMilestoneDependenciesArgs = {
  input: SaveMilestoneDependenciesInput;
};


export type MutationSaveOrderArgs = {
  input: SaveOrderInput;
};


export type MutationSaveOutlookAccountArgs = {
  input: SaveOutlookAccountInput;
};


export type MutationSavePermissionArgs = {
  application: Application;
  name: Scalars['String']['input'];
};


export type MutationSaveProcedureArgs = {
  input: SaveProcedureInput;
};


export type MutationSaveProcedureFromProjectArgs = {
  input: SaveProcedureFromProjectInput;
};


export type MutationSaveProcedureMilestoneDependenciesArgs = {
  input: SaveProcedureMilestoneDependenciesInput;
};


export type MutationSaveProducerArgs = {
  input: SaveProducerInput;
};


export type MutationSaveProducerTrackingArgs = {
  input: ProducerTrackingInput;
};


export type MutationSaveProjectArgs = {
  input?: InputMaybe<SaveProjectInput>;
};


export type MutationSaveProjectMaterialArgs = {
  input: SaveProjectMaterialInput;
};


export type MutationSaveProjectTypeArgs = {
  input: SaveProjectTypeInput;
};


export type MutationSaveRecurringDefinitionArgs = {
  input?: InputMaybe<SaveRecurringDefinitionInput>;
};


export type MutationSaveResourcesArgs = {
  input?: InputMaybe<SaveResourcesInput>;
};


export type MutationSaveRoleArgs = {
  application: Application;
  name: Scalars['String']['input'];
  requiredFeatures?: Array<Feature>;
};


export type MutationSaveSectionArgs = {
  input: SaveSectionInput;
};


export type MutationSaveSizeArgs = {
  input: SaveSizeInput;
};


export type MutationSaveSizeMatrixArgs = {
  input: SaveSizeMatrixInput;
};


export type MutationSaveSizeStandardArgs = {
  input: SaveSizeStandardInput;
};


export type MutationSaveStockRequestsArgs = {
  input: SaveStockRequestsInput;
};


export type MutationSaveSubTaskArgs = {
  input?: InputMaybe<SaveSubTaskInput>;
};


export type MutationSaveSupplierArgs = {
  input: SaveSupplierInput;
};


export type MutationSaveTaskArgs = {
  input?: InputMaybe<SaveTaskInput>;
};


export type MutationSaveTaskReminderArgs = {
  input?: InputMaybe<SaveTaskReminderInput>;
};


export type MutationSaveTeamArgs = {
  input: SaveTeamInput;
};


export type MutationSaveThreadArgs = {
  input: SaveThreadInput;
};


export type MutationSaveThreadDraftArgs = {
  input: SaveThreadDraftInput;
};


export type MutationSaveTimeFactorArgs = {
  input?: InputMaybe<SaveTimeFactorInput>;
};


export type MutationSaveTranslationNoteArgs = {
  input: SaveTranslationNoteInput;
};


export type MutationSaveTranslationsArgs = {
  input: SaveTranslationInput;
};


export type MutationSaveWarehouseArgs = {
  input: SaveWarehouseInput;
};


export type MutationSaveWorkCalendarExceptionPeriodArgs = {
  input: SaveWorkCalendarExceptionPeriodInput;
};


export type MutationSendInvitationArgs = {
  input?: InputMaybe<SendInvitationInput>;
};


export type MutationSetAccountActiveArgs = {
  input: SetAccountActiveInput;
};


export type MutationSetKeyMilestoneReminderArgs = {
  input: SetProjectReminderInput;
};


export type MutationSetNotificationReadArgs = {
  input: NotificationReadStatusInput;
};


export type MutationSetProductionPlanningReminderArgs = {
  input: SetProjectReminderInput;
};


export type MutationSetProjectMaterialsDeadlineArgs = {
  input: SetProjectMaterialsDeadlineInput;
};


export type MutationTaskFollowerActionArgs = {
  input?: InputMaybe<TaskFollowerActionInput>;
};


export type MutationToggleCommentLikeArgs = {
  commentId: Scalars['UUID']['input'];
};


export type MutationToggleProjectFavouriteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationToggleThreadFavouriteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationTransferMaterialsArgs = {
  input: TransferMaterialsInput;
};


export type MutationTransformStandbyToRecurringArgs = {
  input: TransformStandbyToRecurringInput;
};


export type MutationUnfavouriteFashionCollectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUnlinkEntityFromEmailArgs = {
  entityId: Scalars['UUID']['input'];
  messageId: EmailMessageIdInput;
};


export type MutationUnreserveMaterialsArgs = {
  input: ReserveMaterialInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAssignedProducerArgs = {
  input: UpdateAssignedProducerInput;
};


export type MutationUpdateBaseMilestoneArgs = {
  input: UpdateBaseMilestoneInput;
};


export type MutationUpdateBoardArgs = {
  input: UpdateBoardInput;
};


export type MutationUpdateBoardUserSettingsArgs = {
  input: UpdateBoardUserSettingsInput;
};


export type MutationUpdateCategoryArgs = {
  input?: InputMaybe<UpdateCategoryInput>;
};


export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateCustomFieldDefinitionArgs = {
  input: UpdateCustomFieldDefinitionInput;
};


export type MutationUpdateEmailAccountArgs = {
  input: UpdateEmailAccountInput;
};


export type MutationUpdateEmailLinkedEntityArgs = {
  id: Scalars['UUID']['input'];
  shouldPostReplies: Scalars['Boolean']['input'];
};


export type MutationUpdateFashionCollectionArgs = {
  input: UpdateFashionCollectionInput;
};


export type MutationUpdateFashionCollectionItemArgs = {
  input: UpdateFashionCollectionItemInput;
};


export type MutationUpdateFashionCollectionLabelArgs = {
  input?: InputMaybe<UpdateFashionCollectionLabelInput>;
};


export type MutationUpdateFashionCollectionSectionArgs = {
  input: UpdateFashionCollectionSectionInput;
};


export type MutationUpdateGoalArgs = {
  input: UpdateGoalInput;
};


export type MutationUpdateImapAccountArgs = {
  input: UpdateImapAccountInput;
};


export type MutationUpdateJobTitleArgs = {
  input?: InputMaybe<UpdateJobTitleInput>;
};


export type MutationUpdateLabelArgs = {
  input?: InputMaybe<UpdateLabelInput>;
};


export type MutationUpdateLoggedTimeArgs = {
  input?: InputMaybe<UpdateLoggedTimeInput>;
};


export type MutationUpdateManufacturerArgs = {
  input: UpdateManufacturerInput;
};


export type MutationUpdateMaterialArgs = {
  input: UpdateMaterialInput;
};


export type MutationUpdateMaterialTypeArgs = {
  input: UpdateMaterialTypeInput;
};


export type MutationUpdateMaterialsProductionRequestArgs = {
  input: UpdateMaterialsProductionRequestInput;
};


export type MutationUpdateMilestoneArgs = {
  input: UpdateMilestoneInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationInternalArgs = {
  input: UpdateOrganizationInternalInput;
};


export type MutationUpdateProcedureArgs = {
  input: UpdateProcedureInput;
};


export type MutationUpdateProcedureMilestoneArgs = {
  input: UpdateProcedureMilestoneInput;
};


export type MutationUpdateProcedureTaskArgs = {
  input: UpdateProcedureTaskInput;
};


export type MutationUpdateProducerArgs = {
  input: UpdateProducerInput;
};


export type MutationUpdateProjectArgs = {
  input?: InputMaybe<UpdateProjectInput>;
};


export type MutationUpdateProjectMaterialArgs = {
  input: UpdateProjectMaterialInput;
};


export type MutationUpdateProjectMaterialsOwnerArgs = {
  ownerId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationUpdateProjectTypeArgs = {
  input: UpdateProjectTypeInput;
};


export type MutationUpdateRecurringDefinitionArgs = {
  input?: InputMaybe<UpdateRecurringDefinitionInput>;
};


export type MutationUpdateResourceArgs = {
  input?: InputMaybe<UpdateResourceInput>;
};


export type MutationUpdateSectionArgs = {
  input: UpdateSectionInput;
};


export type MutationUpdateSignatureArgs = {
  input: UpdateSignatureInput;
};


export type MutationUpdateSizeArgs = {
  input: UpdateSizeInput;
};


export type MutationUpdateSizeMatrixArgs = {
  input: UpdateSizeMatrixInput;
};


export type MutationUpdateSizeStandardArgs = {
  input: UpdateSizeStandardInput;
};


export type MutationUpdateSupplierArgs = {
  input: UpdateSupplierInput;
};


export type MutationUpdateTaskArgs = {
  input?: InputMaybe<UpdateTaskInput>;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateThreadArgs = {
  input: UpdateThreadInput;
};


export type MutationUpdateThreadDraftArgs = {
  input: UpdateThreadDraftInput;
};


export type MutationUpdateTimeFactorArgs = {
  input?: InputMaybe<UpdateTimeFactorInput>;
};


export type MutationUpdateWarehouseArgs = {
  input: UpdateWarehouseInput;
};


export type MutationUpdateWorkCalendarExceptionPeriodArgs = {
  input: UpdateWorkCalendarExceptionPeriodInput;
};

export type MyTasksInput = {
  additionalFilters: AdditionalTaskFiltersInput;
  filters?: InputMaybe<Array<Array<TaskFilterInput>>>;
  isTodos?: Scalars['Boolean']['input'];
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<TaskSorterInput>>;
};

export enum NomenclatureField {
  IsActive = 'IS_ACTIVE',
  Name = 'NAME'
}

export type NomenclatureFilterInput = {
  field: NomenclatureField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type NomenclatureSorterInput = {
  direction: SortDirection;
  field: NomenclatureField;
};

export type Notification = {
  __typename?: 'Notification';
  action?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<Account>;
  comment?: Maybe<Comment>;
  createdAt?: Maybe<Timestamp>;
  emailAccount?: Maybe<EmailAccount>;
  goal?: Maybe<Goal>;
  id: Scalars['UUID']['output'];
  milestone?: Maybe<Milestone>;
  previousValue?: Maybe<NotificationValue>;
  project?: Maybe<Project>;
  read?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<Resource>;
  snapshot?: Maybe<NotificationValue>;
  task?: Maybe<Task>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum NotificationField {
  Action = 'ACTION',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Project = 'PROJECT',
  Read = 'READ',
  Type = 'TYPE'
}

export type NotificationFilterInput = {
  field: NotificationField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type NotificationReadStatusInput = {
  id: Scalars['UUID']['input'];
  read: Scalars['Boolean']['input'];
};

export type NotificationSorterInput = {
  direction: SortDirection;
  field: NotificationField;
};

export type NotificationValue = NotificationValueAccounts | NotificationValueString | NotificationValueTaskDeleted | Timestamp;

export type NotificationValueAccounts = {
  __typename?: 'NotificationValueAccounts';
  value: Array<Account>;
};

export type NotificationValueString = {
  __typename?: 'NotificationValueString';
  value: Scalars['String']['output'];
};

export type NotificationValueTaskDeleted = {
  __typename?: 'NotificationValueTaskDeleted';
  projectName?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
};

export type Notifications = {
  __typename?: 'Notifications';
  meta?: Maybe<Metadata>;
  notifications?: Maybe<Array<Notification>>;
};

export type OptionalTimestampInput = {
  nanos?: InputMaybe<Scalars['Int']['input']>;
  seconds: Scalars['Int']['input'];
};

export type Order = {
  __typename?: 'Order';
  actualDeliveryDate?: Maybe<Timestamp>;
  billingAddress?: Maybe<Address>;
  confirmedDeliveryDate?: Maybe<Timestamp>;
  createdAt: Timestamp;
  id: Scalars['UUID']['output'];
  materialStatuses: Array<OrderMaterialStatus>;
  materials: Array<OrderMaterial>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  owner: Account;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  reminder?: Maybe<Timestamp>;
  requestedDeliveryDate?: Maybe<Timestamp>;
  requesterAddress?: Maybe<Address>;
  shippingAddress?: Maybe<Address>;
  shippingTerms?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  supplier?: Maybe<Supplier>;
  supplierNotes?: Maybe<Scalars['String']['output']>;
  versions: Array<OrderVersion>;
};

export enum OrderField {
  Manufacturers = 'MANUFACTURERS',
  Materials = 'MATERIALS',
  Number = 'NUMBER',
  Owner = 'OWNER',
  Projects = 'PROJECTS',
  Reminder = 'REMINDER',
  Status = 'STATUS',
  Supplier = 'SUPPLIER'
}

export type OrderFilterInput = {
  field: OrderField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type OrderMaterial = {
  __typename?: 'OrderMaterial';
  material: Material;
  price: Scalars['Float']['output'];
  priceCurrency: Currency;
  project?: Maybe<Project>;
  quantity: Scalars['Int']['output'];
};

export type OrderMaterialInput = {
  materialId: Scalars['UUID']['input'];
  price: Scalars['Float']['input'];
  priceCurrency: Currency;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  quantity: Scalars['Int']['input'];
};

export type OrderMaterialStatus = {
  __typename?: 'OrderMaterialStatus';
  isDelivered: Scalars['Boolean']['output'];
  materialId: Scalars['UUID']['output'];
};

export type OrderMaterialStatusInput = {
  isDelivered: Scalars['Boolean']['input'];
  materialId: Scalars['UUID']['input'];
};

export type OrderSetFilterInput = {
  field: OrderField;
  filters?: Array<OrderFilterInput>;
};

export type OrderSorterInput = {
  direction: SortDirection;
  field: OrderField;
};

export enum OrderStatus {
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  WaitingConfirmation = 'WAITING_CONFIRMATION'
}

export type OrderVersion = {
  __typename?: 'OrderVersion';
  billingAddress: Address;
  createdAt: Timestamp;
  createdBy: Account;
  id: Scalars['UUID']['output'];
  materials: Array<OrderMaterial>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  requestedDeliveryDate: Timestamp;
  requesterAddress: Address;
  shippingAddress: Address;
  shippingTerms?: Maybe<Scalars['String']['output']>;
  supplier: Supplier;
  supplierNotes?: Maybe<Scalars['String']['output']>;
};

export type Orders = {
  __typename?: 'Orders';
  meta: Metadata;
  orders: Array<Order>;
};

export type Organization = {
  __typename?: 'Organization';
  createdAt?: Maybe<Timestamp>;
  currency?: Maybe<Currency>;
  enabledFeatures: Array<Feature>;
  havelockEnabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  industry?: Maybe<OrganizationIndustry>;
  isActive: Scalars['Boolean']['output'];
  language: Language;
  logo?: Maybe<Resource>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  prodactiveEnabled: Scalars['Boolean']['output'];
  providerId: Scalars['String']['output'];
  type: OrganizationType;
  updatedAt?: Maybe<Timestamp>;
  workCalendarExceptionPeriods: Array<WorkCalendarExceptionPeriod>;
  workDayHours: Scalars['Int']['output'];
  workDays: Array<DayOfWeek>;
};

export enum OrganizationIndustry {
  Fashion = 'FASHION'
}

export enum OrganizationType {
  Demo = 'DEMO',
  Evaluation = 'EVALUATION',
  Production = 'PRODUCTION'
}

export type PageRequestInput = {
  includeTotal?: Scalars['Boolean']['input'];
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Pagination = {
  __typename?: 'Pagination';
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Long']['output']>;
};

export type PeriodInput = {
  from: TimestampInput;
  to: TimestampInput;
};

export type Permission = {
  __typename?: 'Permission';
  application: Application;
  name: Scalars['String']['output'];
};

export type PositionCustomFieldDefinitionInput = {
  beforeCustomFieldDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};

export type PositionFashionCollectionInput = {
  afterItemId?: InputMaybe<Scalars['UUID']['input']>;
  fromSectionId: Scalars['UUID']['input'];
  itemId: Scalars['UUID']['input'];
  toSectionId: Scalars['UUID']['input'];
};

export type PositionProcedureMilestoneInput = {
  beforeMilestoneId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};

export type PositionProcedureTaskInput = {
  beforeTaskId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};

export type PositionProjectMaterialInput = {
  afterProjectMaterialId?: InputMaybe<Scalars['UUID']['input']>;
  projectMaterialId: Scalars['UUID']['input'];
};

export type PositionTaskInput = {
  beforeTaskId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};

export type Procedure = {
  __typename?: 'Procedure';
  clients?: Maybe<Array<Client>>;
  createdAt: Timestamp;
  customFieldValues?: Maybe<Array<CustomFieldValue>>;
  hasPriority: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  image?: Maybe<Resource>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  milestones?: Maybe<Array<ProcedureMilestone>>;
  notes?: Maybe<Scalars['String']['output']>;
  producers?: Maybe<Array<Producer>>;
  projectNotes?: Maybe<Scalars['String']['output']>;
  projectType?: Maybe<ProjectType>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Resource>>;
  timeFactor?: Maybe<TimeFactor>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProcedureMilestone = {
  __typename?: 'ProcedureMilestone';
  baseMilestoneId: Scalars['UUID']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isAfterProjectEnd: Scalars['Boolean']['output'];
  isCheckpoint: Scalars['Boolean']['output'];
  label?: Maybe<Label>;
  milestoneDependencyIds: Array<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  procedureId: Scalars['UUID']['output'];
  tasks?: Maybe<Array<ProcedureTask>>;
};

export type ProcedureMilestoneDependencies = {
  __typename?: 'ProcedureMilestoneDependencies';
  milestoneDependencyIds: Array<Scalars['UUID']['output']>;
  milestones?: Maybe<Array<ProcedureMilestone>>;
};

export type ProcedurePropertiesInput = {
  procedureId: Scalars['UUID']['input'];
  resourceIds: Array<Scalars['UUID']['input']>;
  shouldSaveImage?: Scalars['Boolean']['input'];
};

export type ProcedureTask = {
  __typename?: 'ProcedureTask';
  assignees: Array<ProcedureTaskAssignee>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  procedureMilestoneId: Scalars['UUID']['output'];
};

export type ProcedureTaskAssignee = {
  __typename?: 'ProcedureTaskAssignee';
  account: Account;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
};

export type ProcedureTaskAssigneeInput = {
  accountId: Scalars['UUID']['input'];
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
};

export type Procedures = {
  __typename?: 'Procedures';
  meta?: Maybe<Metadata>;
  proceduresList?: Maybe<Array<Procedure>>;
};

export type Producer = {
  __typename?: 'Producer';
  assignments: Array<ProducerAssignment>;
  contactDetails: ContactDetails;
  contacts: Array<Contact>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProducerAssignment = {
  __typename?: 'ProducerAssignment';
  producer: AssignedProducer;
  project: Project;
};

export type ProducerTracking = {
  __typename?: 'ProducerTracking';
  allAssignmentsEffectiveness?: Maybe<Scalars['Int']['output']>;
  dailyProduction?: Maybe<Scalars['Int']['output']>;
  date: Timestamp;
  effectiveness?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  piecesInProduction?: Maybe<Scalars['Int']['output']>;
};

export type ProducerTrackingInput = {
  assignmentId: Scalars['UUID']['input'];
  dailyProduction?: InputMaybe<Scalars['Int']['input']>;
  date: TimestampInput;
  effectiveness?: InputMaybe<Scalars['Int']['input']>;
  piecesInProduction?: InputMaybe<Scalars['Int']['input']>;
};

export type Producers = {
  __typename?: 'Producers';
  meta?: Maybe<Metadata>;
  producers?: Maybe<Array<Producer>>;
};

export enum ProducersField {
  Address = 'ADDRESS',
  Email = 'EMAIL',
  IsActive = 'IS_ACTIVE',
  Name = 'NAME',
  Notes = 'NOTES',
  Phone = 'PHONE'
}

export type ProductionPlanningSettings = MilestoneSettings & {
  __typename?: 'ProductionPlanningSettings';
  isClientsColumnEnabled: Scalars['Boolean']['output'];
  isDeadlineColumnEnabled: Scalars['Boolean']['output'];
  isProvidersColumnEnabled: Scalars['Boolean']['output'];
  isQuantityColumnEnabled: Scalars['Boolean']['output'];
  isResponsibleColumnEnabled: Scalars['Boolean']['output'];
  isTimeFactorColumnEnabled: Scalars['Boolean']['output'];
  isTypeColumnEnabled: Scalars['Boolean']['output'];
  projectTypes: Array<ProjectType>;
  timeFactors: Array<TimeFactor>;
  trackedActivities: Array<TrackedActivity>;
};

export enum ProductionPlanningStatus {
  Done = 'DONE',
  IndicativePlan = 'INDICATIVE_PLAN',
  InProduction = 'IN_PRODUCTION',
  Planned = 'PLANNED'
}

export type Project = {
  __typename?: 'Project';
  access: ProjectAccess;
  allowedStatuses: Array<Status>;
  assignedProducers: Array<AssignedProducer>;
  canLoadProcedure: Scalars['Boolean']['output'];
  clients: Array<Client>;
  completionPercentage?: Maybe<Scalars['Int']['output']>;
  createdAt: Timestamp;
  createdBy: Account;
  customFieldValues: Array<CustomFieldValue>;
  deadline: Timestamp;
  deadlinesCalculatedAt?: Maybe<Timestamp>;
  delay?: Maybe<Scalars['Int']['output']>;
  earliestOrderReminder?: Maybe<Timestamp>;
  executionDate?: Maybe<Timestamp>;
  fashionCollectionItems: Array<FashionCollectionItem>;
  finalCost?: Maybe<Scalars['String']['output']>;
  goals: Array<Goal>;
  hasPriority: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  image?: Maybe<Resource>;
  isBomComplete: Scalars['Boolean']['output'];
  isFavourite: Scalars['Boolean']['output'];
  keyMilestones: Array<Milestone>;
  keyMilestonesReminder?: Maybe<Timestamp>;
  materials: Array<ProjectMaterial>;
  materialsProductionRequests: Array<MaterialsProductionRequest>;
  milestones: Array<Milestone>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  productionPlanningMilestones: Array<Milestone>;
  productionPlanningReminder?: Maybe<Timestamp>;
  productionPlanningStatuses: Array<ProductionPlanningStatus>;
  projectType: ProjectType;
  quantity?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  resources: Array<Resource>;
  responsible: Account;
  sizeMatrices: Array<SizeMatrix>;
  startDate: Timestamp;
  status: Status;
  targetCost?: Maybe<Scalars['String']['output']>;
  teamContributors: Array<TeamContributor>;
  timeFactor?: Maybe<TimeFactor>;
  updatedAt?: Maybe<Timestamp>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userAccess?: Maybe<UserAccess>;
  userContributors: Array<UserContributor>;
  wereDeadlinesCalculatedFromStart?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProjectAccess {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Shared = 'SHARED'
}

export type ProjectDetailsCounters = {
  __typename?: 'ProjectDetailsCounters';
  milestonesCount: Scalars['Int']['output'];
  projectId: Scalars['UUID']['output'];
  projectMaterialsCount: Scalars['Int']['output'];
  resourcesCount: Scalars['Int']['output'];
  sizeMatricesCount: Scalars['Int']['output'];
};

export type ProjectEvent = Event & {
  __typename?: 'ProjectEvent';
  project: Project;
  type: EventType;
};

export type ProjectEventUnion = EntityDeletedEvent | ProjectEvent;

export enum ProjectField {
  Clients = 'CLIENTS',
  Deadline = 'DEADLINE',
  Delay = 'DELAY',
  ExecutionDate = 'EXECUTION_DATE',
  Goals = 'GOALS',
  HasPriority = 'HAS_PRIORITY',
  Name = 'NAME',
  Notes = 'NOTES',
  Producers = 'PRODUCERS',
  ProductionPlanningStatus = 'PRODUCTION_PLANNING_STATUS',
  ProjectType = 'PROJECT_TYPE',
  Quantity = 'QUANTITY',
  Reference = 'REFERENCE',
  Responsible = 'RESPONSIBLE',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TimeFactor = 'TIME_FACTOR'
}

export type ProjectFieldValueWrapper = {
  __typename?: 'ProjectFieldValueWrapper';
  value: ProjectField;
};

export type ProjectFilterInput = {
  field: ProjectField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type ProjectMaterial = {
  __typename?: 'ProjectMaterial';
  additionalReferenceNumbers?: Maybe<Array<AdditionalReferenceNumber>>;
  consumption: Consumption;
  consumptions: Array<ProjectMaterialConsumption>;
  id: Scalars['UUID']['output'];
  isFulfilled: Scalars['Boolean']['output'];
  isFullyOrdered: Scalars['Boolean']['output'];
  isFullyReserved: Scalars['Boolean']['output'];
  isProcessing?: Maybe<Scalars['Boolean']['output']>;
  leadTime?: Maybe<Scalars['Int']['output']>;
  material: Material;
  notes?: Maybe<Scalars['String']['output']>;
  orderReminder?: Maybe<Timestamp>;
  orderedQuantity: Scalars['Int']['output'];
  orders: Array<Order>;
  owner: Account;
  price?: Maybe<Scalars['Float']['output']>;
  priceCurrency?: Maybe<Currency>;
  prices?: Maybe<Array<ProjectMaterialPrice>>;
  project: Project;
  reservedQuantity: Scalars['Int']['output'];
  sizeMatrixItems: Array<SizeMatrixItem>;
  supplier: Supplier;
  targetDeadline?: Maybe<Timestamp>;
  targetDeadlineMilestone?: Maybe<Milestone>;
  warehouseQuantity: ProjectMaterialWarehouseQuantity;
};

export type ProjectMaterialConsumption = {
  __typename?: 'ProjectMaterialConsumption';
  consumption: Consumption;
  name: Scalars['String']['output'];
};

export type ProjectMaterialConsumptionInput = {
  consumption: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

export enum ProjectMaterialField {
  Client = 'CLIENT',
  Colour = 'COLOUR',
  Content = 'CONTENT',
  IsBomComplete = 'IS_BOM_COMPLETE',
  IsFullyOrdered = 'IS_FULLY_ORDERED',
  IsFullyReserved = 'IS_FULLY_RESERVED',
  IsProcessing = 'IS_PROCESSING',
  LeadTime = 'LEAD_TIME',
  Manufacturer = 'MANUFACTURER',
  Material = 'MATERIAL',
  MaterialType = 'MATERIAL_TYPE',
  Name = 'NAME',
  Owner = 'OWNER',
  Project = 'PROJECT',
  ReferenceNumber = 'REFERENCE_NUMBER',
  Size = 'SIZE',
  Supplier = 'SUPPLIER'
}

export type ProjectMaterialPrice = {
  __typename?: 'ProjectMaterialPrice';
  currency: Currency;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type ProjectMaterialPriceInput = {
  currency: Currency;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type ProjectMaterialWarehouseQuantity = {
  __typename?: 'ProjectMaterialWarehouseQuantity';
  clientQuantity: Scalars['Int']['output'];
  totalQuantity: Scalars['Int']['output'];
};

export type ProjectMaterials = {
  __typename?: 'ProjectMaterials';
  meta: Metadata;
  projectMaterials: Array<ProjectMaterial>;
};

export type ProjectSorterInput = {
  direction: SortDirection;
  field: ProjectField;
};

export type ProjectType = {
  __typename?: 'ProjectType';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProjectTypes = {
  __typename?: 'ProjectTypes';
  meta?: Maybe<Metadata>;
  projectTypes?: Maybe<Array<Maybe<ProjectType>>>;
};

export type Projects = {
  __typename?: 'Projects';
  meta?: Maybe<Metadata>;
  projects: Array<Project>;
};

export type ProjectsQuantityResponse = {
  __typename?: 'ProjectsQuantityResponse';
  averageQuantity: Scalars['Float']['output'];
  totalQuantity: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  allAccounts: Array<Account>;
  allAddresses: Array<Address>;
  allRoles: Array<Role>;
  allTeams: Array<Team>;
  allThreadDrafts: Array<ThreadDraft>;
  allWarehouses: Array<Warehouse>;
  calculateMilestoneDeadlines: Array<Milestone>;
  checkInvitation: CheckInvitationResponse;
  currentAccountOrganizations: Array<Organization>;
  customFieldDefinitions: Array<CustomFieldDefinition>;
  dashboardCounters: DashboardCounters;
  dynamicPlannings: Array<DynamicPlanning>;
  emailSignatures: Array<EmailSignature>;
  exportProjects: Scalars['Boolean']['output'];
  exportTimeTrackingReport: Scalars['Boolean']['output'];
  favouriteThreads: Array<Thread>;
  getAccount: Account;
  getAccounts: Array<Account>;
  getAssignedGoals: Array<Goal>;
  getBaseMilestone: BaseMilestone;
  getBoard: Board;
  getBoardsSetFilters: SetFilterResponse;
  getCategoriesForContextType: Array<Category>;
  getCategory?: Maybe<Category>;
  getClient: Client;
  getComment: Comment;
  getCommentsSetFilters: SetFilterResponse;
  getCounters?: Maybe<Counters>;
  getCurrentUserAccount: Account;
  getEmailAccount: EmailAccount;
  getEmailLinkedEntities: Array<EmailLinkedEntity>;
  getFashionCollection: FashionCollection;
  getFashionCollectionItem: FashionCollectionItem;
  getFashionCollectionItemsSetFilters: SetFilterResponse;
  getFollowedGoals: Array<Goal>;
  getForRecurring?: Maybe<Tasks>;
  getGoal: Goal;
  getGoalsSetFilters: SetFilterResponse;
  getGoalsWithReminder: Array<Goal>;
  getInvitation?: Maybe<Invitation>;
  getInvitations: Invitations;
  getInvitationsSetFilters: SetFilterResponse;
  getJob: Job;
  getJobTitle: JobTitle;
  getLastUpdateDateForTranslation?: Maybe<Timestamp>;
  getLogEntries: Array<LogEntry>;
  getLoggedTimes: Array<LoggedTime>;
  getMaterials: Array<Material>;
  getMaterialsProductionRequest: MaterialsProductionRequest;
  getMaterialsProductionRequestsSetFilters: SetFilterResponse;
  getMaterialsSetFilters: SetFilterResponse;
  getMilestone?: Maybe<Milestone>;
  getMilestoneDependencies?: Maybe<MilestoneDependencies>;
  getMilestonesProjectCustomFieldSetFilters: Array<CustomFieldValue>;
  getMilestonesSetFilters: SetFilterResponse;
  getMyTasksSetFilters?: Maybe<SetFilterResponse>;
  getNotificationSetFilters: SetFilterResponse;
  getOrder: Order;
  getOrdersSetFilters: SetFilterResponse;
  getOwnedGoals: Array<Goal>;
  getProcedure?: Maybe<Procedure>;
  getProcedureMilestoneDependencies?: Maybe<ProcedureMilestoneDependencies>;
  getProject?: Maybe<Project>;
  getProjectDetailsCounters: ProjectDetailsCounters;
  getProjectMaterial: ProjectMaterial;
  getProjectMaterialsSetFilters: SetFilterResponse;
  getProjectsCustomFieldSetFilters: Array<CustomFieldValue>;
  getProjectsQuantity: ProjectsQuantityResponse;
  getProjectsSetFilters?: Maybe<SetFilterResponse>;
  getRecurringDefinition?: Maybe<RecurringTaskDefinition>;
  getRecurringTasksSetFilters: SetFilterResponse;
  getResource?: Maybe<Resource>;
  getResourcePolicy?: Maybe<ResourcePolicy>;
  getResourcesSetFilters?: Maybe<SetFilterResponse>;
  getSizeMatricesSetFilters: SetFilterResponse;
  getStockRequest: StockRequest;
  getTask: Task;
  getTaskDetailsCounters: TaskDetailsCounters;
  getTasksReportDirectSourceFilters: Array<TaskDirectSourceFilter>;
  getTasksReportSetFilters: SetFilterResponse;
  getTeams: Array<Team>;
  getThread: Thread;
  getThreadDraft: ThreadDraft;
  getThreadsSetFilters: SetFilterResponse;
  getTimeTrackingReport: TimeTrackingReport;
  getTimeTrackingReportTotals?: Maybe<TimeTrackingReportTotals>;
  getTimeTrackingSetFilters?: Maybe<SetFilterResponse>;
  getTransactionsSetFilters: SetFilterResponse;
  getTranslation: Translations;
  getWarehouseMaterialsSetFilters: SetFilterResponse;
  googleEmailAuthorizationUrl: Scalars['String']['output'];
  internalUsageReport: Array<InternalUsageReportRow>;
  myTasks?: Maybe<Tasks>;
  myTeamMembersActivity: Array<TeamMemberActivity>;
  outlookAuthorizationUrl: Scalars['String']['output'];
  recentThreadContacts: Array<RecentThreadContacts>;
  recentThreadLabels: Array<RecentThreadLabelGroup>;
  recentThreads: ThreadActivities;
  rewordComment: Scalars['String']['output'];
  searchBaseMilestones?: Maybe<BaseMilestones>;
  searchBoards: Boards;
  searchCategories?: Maybe<Categories>;
  searchClients?: Maybe<Clients>;
  searchComments: Comments;
  searchFashionCollectionItems: FashionCollectionItems;
  searchFashionCollectionLabels: FashionCollectionLabels;
  searchFashionCollections: FashionCollections;
  searchGoals: Goals;
  searchJobTitle?: Maybe<JobTitles>;
  searchLabels?: Maybe<LabelsResponse>;
  searchManufacturers: Manufacturers;
  searchMaterialTypes: MaterialTypes;
  searchMaterials: Materials;
  searchMaterialsProductionRequests: MaterialsProductionRequests;
  searchMilestones: Milestones;
  searchNotifications: Notifications;
  searchOrders: Orders;
  searchOrganizations: Array<Organization>;
  searchProcedures?: Maybe<Procedures>;
  searchProducers?: Maybe<Producers>;
  searchProjectMaterials: ProjectMaterials;
  searchProjectType?: Maybe<ProjectTypes>;
  searchProjects?: Maybe<Projects>;
  searchResource: Resources;
  searchRoles: Array<Role>;
  searchSizeMatrices: SizeMatrices;
  searchSizeStandards: SizeStandards;
  searchSuppliers: Suppliers;
  searchThreads: Threads;
  searchTimeFactor?: Maybe<TimeFactors>;
  searchTransactionDocuments: TransactionDocuments;
  searchTransactions: Transactions;
  searchWarehouseMaterialInventories: WarehouseMaterialInventories;
  summariseComments: Scalars['String']['output'];
  tasksReport: Tasks;
  testImapAccount: EmptyResponse;
  threadCounters: ThreadCounters;
  usageReport: Array<UsageReportRow>;
  validateProjectImport: ValidateProjectImportResponse;
};


export type QueryCalculateMilestoneDeadlinesArgs = {
  input: CalculateMilestoneDeadlinesInput;
};


export type QueryCheckInvitationArgs = {
  input?: InputMaybe<CheckInvitationInput>;
};


export type QueryDashboardCountersArgs = {
  input: DashboardCounterInput;
};


export type QueryExportProjectsArgs = {
  input: ExportProjectsInput;
};


export type QueryExportTimeTrackingReportArgs = {
  reportInput: TimeTrackingReportInput;
  selectedTaskColumns: Array<TaskField>;
  selectedTimeTrackingColumns: Array<TimeTrackingField>;
};


export type QueryGetAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetAccountsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryGetBaseMilestoneArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetBoardArgs = {
  input: GetBoardInput;
};


export type QueryGetBoardsSetFiltersArgs = {
  input: BoardsSetFilterInput;
};


export type QueryGetCategoriesForContextTypeArgs = {
  input: GetCategoriesForContextTypeInput;
};


export type QueryGetCategoryArgs = {
  input?: InputMaybe<GetCategoryInput>;
};


export type QueryGetClientArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetCommentArgs = {
  commentId: Scalars['UUID']['input'];
};


export type QueryGetCommentsSetFiltersArgs = {
  input: CommentsSetFilterInput;
};


export type QueryGetEmailAccountArgs = {
  emailAccountId: Scalars['UUID']['input'];
};


export type QueryGetEmailLinkedEntitiesArgs = {
  messageId: EmailMessageIdInput;
};


export type QueryGetFashionCollectionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetFashionCollectionItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetFashionCollectionItemsSetFiltersArgs = {
  input: FashionCollectionItemsSetFilterInput;
};


export type QueryGetForRecurringArgs = {
  input?: InputMaybe<GetForRecurringInput>;
};


export type QueryGetGoalArgs = {
  input?: InputMaybe<GetGoalInput>;
};


export type QueryGetGoalsSetFiltersArgs = {
  input: GoalsSetFilterInput;
};


export type QueryGetGoalsWithReminderArgs = {
  priorTo: TimestampInput;
};


export type QueryGetInvitationArgs = {
  input?: InputMaybe<GetInvitationInput>;
};


export type QueryGetInvitationsArgs = {
  input?: InputMaybe<GetInvitationsInput>;
};


export type QueryGetInvitationsSetFiltersArgs = {
  input?: InputMaybe<InvitationSetFilterInput>;
};


export type QueryGetJobArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetJobTitleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetLastUpdateDateForTranslationArgs = {
  language: Language;
};


export type QueryGetLogEntriesArgs = {
  input: GetLogEntriesInput;
};


export type QueryGetLoggedTimesArgs = {
  input: GetTaskInput;
};


export type QueryGetMaterialsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryGetMaterialsProductionRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetMaterialsProductionRequestsSetFiltersArgs = {
  input: MaterialsProductionRequestsSetFilterInput;
};


export type QueryGetMaterialsSetFiltersArgs = {
  input: MaterialsSetFilterInput;
};


export type QueryGetMilestoneArgs = {
  input?: InputMaybe<GetMilestoneInput>;
};


export type QueryGetMilestoneDependenciesArgs = {
  input?: InputMaybe<GetMilestoneDependenciesInput>;
};


export type QueryGetMilestonesProjectCustomFieldSetFiltersArgs = {
  input: GetMilestonesProjectCustomFieldSetFiltersInput;
};


export type QueryGetMilestonesSetFiltersArgs = {
  input: GetMilestonesSetFiltersInput;
};


export type QueryGetMyTasksSetFiltersArgs = {
  input?: InputMaybe<GetMyTasksSetFiltersInput>;
};


export type QueryGetNotificationSetFiltersArgs = {
  input: GetNotificationSetFiltersInput;
};


export type QueryGetOrderArgs = {
  orderId: Scalars['UUID']['input'];
};


export type QueryGetOrdersSetFiltersArgs = {
  input: OrderSetFilterInput;
};


export type QueryGetProcedureArgs = {
  input?: InputMaybe<GetProcedureInput>;
};


export type QueryGetProcedureMilestoneDependenciesArgs = {
  input?: InputMaybe<GetProcedureMilestoneDependenciesInput>;
};


export type QueryGetProjectArgs = {
  input?: InputMaybe<GetProjectInput>;
};


export type QueryGetProjectDetailsCountersArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetProjectMaterialArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetProjectMaterialsSetFiltersArgs = {
  input: GetProjectMaterialSetFilterInput;
};


export type QueryGetProjectsCustomFieldSetFiltersArgs = {
  input: GetProjectsCustomFieldSetFiltersInput;
};


export type QueryGetProjectsQuantityArgs = {
  input?: InputMaybe<GetProjectsQuantityInput>;
};


export type QueryGetProjectsSetFiltersArgs = {
  input?: InputMaybe<GetProjectsSetFiltersInput>;
};


export type QueryGetRecurringDefinitionArgs = {
  input?: InputMaybe<RecurringDefinitionIdInput>;
};


export type QueryGetRecurringTasksSetFiltersArgs = {
  input: RecurringTaskSetFilterInput;
};


export type QueryGetResourceArgs = {
  input?: InputMaybe<GetResourceInput>;
};


export type QueryGetResourcePolicyArgs = {
  input?: InputMaybe<GetResourcePolicyInput>;
};


export type QueryGetResourcesSetFiltersArgs = {
  input?: InputMaybe<GetResourceSetFiltersInput>;
};


export type QueryGetSizeMatricesSetFiltersArgs = {
  input: SizeMatricesSetFilterInput;
};


export type QueryGetStockRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetTaskArgs = {
  input: GetTaskInput;
};


export type QueryGetTaskDetailsCountersArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetTasksReportDirectSourceFiltersArgs = {
  input: TasksReportSetFiltersInput;
};


export type QueryGetTasksReportSetFiltersArgs = {
  input: TasksReportSetFiltersInput;
};


export type QueryGetTeamsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryGetThreadArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetThreadDraftArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetThreadsSetFiltersArgs = {
  input: ThreadsSetFilterInput;
};


export type QueryGetTimeTrackingReportArgs = {
  input: TimeTrackingReportInput;
};


export type QueryGetTimeTrackingReportTotalsArgs = {
  input?: InputMaybe<TimeTrackingReportInput>;
};


export type QueryGetTimeTrackingSetFiltersArgs = {
  input?: InputMaybe<TimeTrackingReportSetFilterInput>;
};


export type QueryGetTransactionsSetFiltersArgs = {
  input: TransactionsSetFiltersInput;
};


export type QueryGetTranslationArgs = {
  language: Language;
};


export type QueryGetWarehouseMaterialsSetFiltersArgs = {
  input: WarehouseMaterialInventoriesSetFiltersInput;
};


export type QueryGoogleEmailAuthorizationUrlArgs = {
  emailAccountId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryInternalUsageReportArgs = {
  input: InternalUsageReportInput;
};


export type QueryMyTasksArgs = {
  input?: InputMaybe<MyTasksInput>;
};


export type QueryMyTeamMembersActivityArgs = {
  period: PeriodInput;
};


export type QueryRecentThreadsArgs = {
  pageRequest: PageRequestInput;
  unreadOnly?: Scalars['Boolean']['input'];
};


export type QueryRewordCommentArgs = {
  input: RewordCommentInput;
};


export type QuerySearchBaseMilestonesArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchBoardsArgs = {
  input: SearchBoardsInput;
};


export type QuerySearchCategoriesArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchClientsArgs = {
  input?: InputMaybe<SearchClientsInput>;
};


export type QuerySearchCommentsArgs = {
  input: SearchCommentsInput;
};


export type QuerySearchFashionCollectionItemsArgs = {
  input: SearchFashionCollectionItemsInput;
};


export type QuerySearchFashionCollectionLabelsArgs = {
  input?: InputMaybe<SearchFashionCollectionLabelsInput>;
};


export type QuerySearchFashionCollectionsArgs = {
  input: SearchFashionCollectionsInput;
};


export type QuerySearchGoalsArgs = {
  input: SearchGoalsInput;
};


export type QuerySearchJobTitleArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchLabelsArgs = {
  input?: InputMaybe<SearchLabelsInput>;
};


export type QuerySearchManufacturersArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchMaterialTypesArgs = {
  input: SearchNomenclatureInput;
};


export type QuerySearchMaterialsArgs = {
  input: SearchMaterialsInput;
};


export type QuerySearchMaterialsProductionRequestsArgs = {
  input: SearchMaterialsProductionRequestsInput;
};


export type QuerySearchMilestonesArgs = {
  input: SearchMilestonesInput;
};


export type QuerySearchNotificationsArgs = {
  input: SearchNotificationsInput;
};


export type QuerySearchOrdersArgs = {
  input: SearchOrderInput;
};


export type QuerySearchProceduresArgs = {
  input?: InputMaybe<SearchProceduresInput>;
};


export type QuerySearchProducersArgs = {
  input?: InputMaybe<SearchProducersInput>;
};


export type QuerySearchProjectMaterialsArgs = {
  input: SearchProjectMaterialsInput;
};


export type QuerySearchProjectTypeArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchProjectsArgs = {
  input?: InputMaybe<SearchProjectsInput>;
};


export type QuerySearchResourceArgs = {
  input: SearchResourceInput;
};


export type QuerySearchSizeMatricesArgs = {
  input: SearchSizeMatricesInput;
};


export type QuerySearchSizeStandardsArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchSuppliersArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchThreadsArgs = {
  input: SearchThreadsInput;
};


export type QuerySearchTimeFactorArgs = {
  input?: InputMaybe<SearchNomenclatureInput>;
};


export type QuerySearchTransactionDocumentsArgs = {
  input: SearchTransactionDocumentsInput;
};


export type QuerySearchTransactionsArgs = {
  input: SearchTransactionsInput;
};


export type QuerySearchWarehouseMaterialInventoriesArgs = {
  input: SearchWarehouseMaterialInventoriesInput;
};


export type QuerySummariseCommentsArgs = {
  entityId: Scalars['UUID']['input'];
  entityType: CommentEntityType;
  language: Language;
};


export type QueryTasksReportArgs = {
  input: TasksReportInput;
};


export type QueryTestImapAccountArgs = {
  input: SaveImapAccountInput;
};


export type QueryUsageReportArgs = {
  input: UsageReportInput;
};


export type QueryValidateProjectImportArgs = {
  input: SaveResourceInput;
};

export type RecentThreadContacts = {
  __typename?: 'RecentThreadContacts';
  accounts: Array<Account>;
  teams: Array<Team>;
};

export type RecentThreadLabelGroup = {
  __typename?: 'RecentThreadLabelGroup';
  labels: Array<Label>;
};

export type RecurringDefinitionEvent = Event & {
  __typename?: 'RecurringDefinitionEvent';
  definition: RecurringTaskDefinition;
  type: EventType;
};

export type RecurringDefinitionIdInput = {
  id: Scalars['UUID']['input'];
};

export enum RecurringPeriod {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

export enum RecurringStatus {
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED'
}

export type RecurringTaskConfig = {
  __typename?: 'RecurringTaskConfig';
  assigneeId: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type RecurringTaskConfigInput = {
  assigneeId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type RecurringTaskDefinition = {
  __typename?: 'RecurringTaskDefinition';
  assignees: Array<Account>;
  createDaysBeforeDeadline: Scalars['Int']['output'];
  daysOfMonthList?: Maybe<Array<Scalars['Int']['output']>>;
  daysOfWeekList?: Maybe<Array<Scalars['Int']['output']>>;
  deadline?: Maybe<Timestamp>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  fashionCollectionItem?: Maybe<FashionCollectionItem>;
  followers: Array<Account>;
  goal?: Maybe<Goal>;
  id: Scalars['UUID']['output'];
  milestoneId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  occurrences?: Maybe<Scalars['Int']['output']>;
  onDateOfYear?: Maybe<Timestamp>;
  owner: Account;
  projectId?: Maybe<Scalars['UUID']['output']>;
  recurringEnd?: Maybe<Timestamp>;
  recurringPeriod: RecurringPeriod;
  recurringPeriodInterval: Scalars['Int']['output'];
  startDate: Timestamp;
  status: RecurringStatus;
  tasksConfig: Array<RecurringTaskConfig>;
};

export type RecurringTaskSetFilterInput = {
  field: TaskField;
  filters?: InputMaybe<Array<TaskFilterInput>>;
  recurringId: Scalars['UUID']['input'];
};

export enum ReminderType {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Hour = 'HOUR',
  Week = 'WEEK'
}

export type RemoveTaskReminderInput = {
  taskId: Scalars['UUID']['input'];
};

export type ReplaceTaskAssigneeInput = {
  assignee: TaskAssigneeInput;
  id: Scalars['UUID']['input'];
};

export type ResendInvitationInput = {
  id: Scalars['UUID']['input'];
};

export type ReserveMaterialInput = {
  documents?: Array<TransactionDocumentInput>;
  materials: Array<ReserveTransactionMaterialInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['UUID']['input'];
};

export type ReserveTransactionMaterialInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  materialId: Scalars['UUID']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  quantity: Scalars['Int']['input'];
};

export type Resource = {
  __typename?: 'Resource';
  access: ResourceAccess;
  account: Account;
  alias?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  commentId?: Maybe<Scalars['UUID']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Timestamp;
  fashionCollectionItem?: Maybe<FashionCollectionItem>;
  goal?: Maybe<Goal>;
  id: Scalars['UUID']['output'];
  isInline: Scalars['Boolean']['output'];
  isLink: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Material>;
  milestone?: Maybe<Milestone>;
  name: Scalars['String']['output'];
  presignedDownloadUrl?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  size?: Maybe<Scalars['Long']['output']>;
  task?: Maybe<Task>;
  teamContributors: Array<TeamContributor>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Timestamp>;
  userAccess?: Maybe<UserAccess>;
  userContributors: Array<UserContributor>;
};

export enum ResourceAccess {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type ResourceEvent = Event & {
  __typename?: 'ResourceEvent';
  resource: Resource;
  type: EventType;
};

export type ResourceEventUnion = EntityDeletedEvent | ResourceEvent;

export enum ResourceField {
  Access = 'ACCESS',
  Alias = 'ALIAS',
  Category = 'CATEGORY',
  Date = 'DATE',
  Name = 'NAME',
  Size = 'SIZE',
  SourceType = 'SOURCE_TYPE',
  UploadedBy = 'UPLOADED_BY'
}

export type ResourceFilterInput = {
  field: ResourceField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type ResourcePolicy = {
  __typename?: 'ResourcePolicy';
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ResourceSorterInput = {
  direction: SortDirection;
  field: ResourceField;
};

export type Resources = {
  __typename?: 'Resources';
  meta: Metadata;
  resources?: Maybe<Array<Resource>>;
};

export type RewordCommentInput = {
  content: Scalars['String']['input'];
  language?: InputMaybe<Language>;
  rewordOption: RewordOption;
};

export enum RewordOption {
  Casual = 'CASUAL',
  Formal = 'FORMAL',
  Proofread = 'PROOFREAD',
  Summarize = 'SUMMARIZE',
  Translate = 'TRANSLATE'
}

export type Role = {
  __typename?: 'Role';
  application: Application;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type SaveAccountInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type SaveAccountResponse = EmailAccount | ErrorResponse;

export type SaveAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type SaveBaseMilestoneInput = {
  isActive: Scalars['Boolean']['input'];
  isCheckpoint?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type SaveBoardInput = {
  name: Scalars['String']['input'];
  ownerId: Scalars['UUID']['input'];
  teamContributors?: Array<TeamContributorInput>;
  userContributors?: Array<UserContributorInput>;
};

export type SaveCategoryInput = {
  isDefaultType: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type SaveClientInput = {
  contactDetails: ContactDetailsInput;
  contacts?: Array<SaveContactInput>;
  name: Scalars['String']['input'];
};

export type SaveCommentInput = {
  deadlineRequest?: InputMaybe<DeadlineRequestInput>;
  emailEnvelopeInput?: InputMaybe<EmailEnvelopeInput>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  fashionCollectionItemId?: InputMaybe<Scalars['UUID']['input']>;
  goalId?: InputMaybe<Scalars['UUID']['input']>;
  onBehalfOfId?: InputMaybe<Scalars['UUID']['input']>;
  parentCommentId?: InputMaybe<Scalars['UUID']['input']>;
  recipients: SaveRecipientsInput;
  resources?: InputMaybe<Array<SaveResourceInput>>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  text: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SaveCommentReminderInput = {
  commentId: Scalars['UUID']['input'];
  remindAt: TimestampInput;
  type: ReminderType;
};

export type SaveCommentResponse = Comment | ErrorResponse;

export type SaveContactInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  contactDetails: ContactDetailsInput;
  firstName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  manufacturerId?: InputMaybe<Scalars['UUID']['input']>;
  producerId?: InputMaybe<Scalars['UUID']['input']>;
  supplierId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SaveCustomFieldDefinitionInput = {
  contributors: UpdateContributorsAccessInput;
  description?: InputMaybe<Scalars['String']['input']>;
  enumEntries?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  table: Table;
  tooltip?: InputMaybe<Scalars['String']['input']>;
  type: CustomFieldType;
};

export type SaveFashionCollectionInput = {
  name: Scalars['String']['input'];
  ownerId: Scalars['UUID']['input'];
  teamContributors?: Array<TeamContributorInput>;
  userContributors?: Array<UserContributorInput>;
};

export type SaveFashionCollectionItemInput = {
  labelIds: Array<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  projectIds: Array<Scalars['UUID']['input']>;
  resources: Array<SaveResourceInput>;
  sectionId: Scalars['UUID']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type SaveFashionCollectionLabelInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SaveFashionCollectionSectionInput = {
  collectionId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type SaveGoalInput = {
  assigneeId?: InputMaybe<Scalars['UUID']['input']>;
  comment?: InputMaybe<FirstCommentInput>;
  deadline?: InputMaybe<TimestampInput>;
  followerIds?: Array<Scalars['UUID']['input']>;
  labelIds?: Array<Scalars['UUID']['input']>;
  linkedEmail?: InputMaybe<LinkEntityToEmailLinkInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['UUID']['input'];
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  projectIds?: Array<Scalars['UUID']['input']>;
  remindMe?: InputMaybe<TimestampInput>;
  resources?: Array<SaveResourceInput>;
  sectionId: Scalars['UUID']['input'];
  teamFollowerIds?: Array<Scalars['UUID']['input']>;
};

export type SaveGoogleEmailAccountInput = {
  authorizationCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  otherAccountIds?: Array<Scalars['UUID']['input']>;
};

export type SaveImapAccountInput = {
  email: Scalars['String']['input'];
  imapHost: Scalars['String']['input'];
  imapPassword: Scalars['String']['input'];
  imapPort?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  newEmailSignatureId?: InputMaybe<Scalars['UUID']['input']>;
  otherAccountIds?: Array<Scalars['UUID']['input']>;
  replySignatureId?: InputMaybe<Scalars['UUID']['input']>;
  smtpHost: Scalars['String']['input'];
  smtpPort?: Scalars['Int']['input'];
};

export type SaveJobTitleInput = {
  application: Application;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type SaveLabelInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SaveLoggedTimeInput = {
  hours: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  taskId: Scalars['UUID']['input'];
  time: TimestampInput;
};

export type SaveManufacturerInput = {
  contactDetails: ContactDetailsInput;
  contacts?: Array<SaveContactInput>;
  name: Scalars['String']['input'];
};

export type SaveMaterialInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<SaveResourceInput>;
  isProcessing: Scalars['Boolean']['input'];
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  manufacturerId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  priceCurrency?: InputMaybe<Currency>;
  referenceNumber: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['UUID']['input'];
};

export type SaveMaterialTypeInput = {
  name: Scalars['String']['input'];
};

export type SaveMaterialsProductionRequestInput = {
  items: Array<MaterialsProductionRequestItemInput>;
  ownerId: Scalars['UUID']['input'];
  productionNotes?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
  reminder: TimestampInput;
  warehouseNotes?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMilestoneDependenciesInput = {
  milestoneDependencyIds: Array<Scalars['UUID']['input']>;
  milestoneId: Scalars['UUID']['input'];
};

export type SaveMilestoneInput = {
  baseId?: InputMaybe<Scalars['UUID']['input']>;
  duration?: Scalars['Int']['input'];
  isCheckpoint?: Scalars['Boolean']['input'];
  isDeadlineLocked?: Scalars['Boolean']['input'];
  labelId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['UUID']['input'];
  resources?: InputMaybe<Array<SaveResourceInput>>;
  targetDeadline?: InputMaybe<TimestampInput>;
};

export type SaveOrderInput = {
  billingAddressId?: InputMaybe<Scalars['UUID']['input']>;
  isDraft?: Scalars['Boolean']['input'];
  materials: Array<OrderMaterialInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['UUID']['input'];
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<TimestampInput>;
  requestedDeliveryDate?: InputMaybe<TimestampInput>;
  requesterAddressId?: InputMaybe<Scalars['UUID']['input']>;
  shippingAddressId?: InputMaybe<Scalars['UUID']['input']>;
  shippingTerms?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['UUID']['input']>;
  supplierNotes?: InputMaybe<Scalars['String']['input']>;
};

export type SaveOutlookAccountInput = {
  authorizationCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  otherAccountIds?: Array<Scalars['UUID']['input']>;
};

export type SaveProcedureFromProjectInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
  shouldSaveProjectDetails?: Scalars['Boolean']['input'];
  shouldSaveResources?: Scalars['Boolean']['input'];
  shouldSaveTasks?: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type SaveProcedureInput = {
  clientIds?: Array<Scalars['UUID']['input']>;
  customFieldValues?: Array<CustomFieldValueInput>;
  hasPriority?: Scalars['Boolean']['input'];
  milestones: Array<SaveProcedureMilestoneInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  producerIds?: Array<Scalars['UUID']['input']>;
  projectNotes?: InputMaybe<Scalars['String']['input']>;
  projectTypeId?: InputMaybe<Scalars['UUID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  resources?: Array<SaveResourceInput>;
  timeFactorId?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
};

export type SaveProcedureMilestoneDependenciesInput = {
  milestoneDependencyIds: Array<Scalars['UUID']['input']>;
  procedureMilestoneId: Scalars['UUID']['input'];
};

export type SaveProcedureMilestoneInput = {
  baseMilestoneId: Scalars['UUID']['input'];
  duration?: Scalars['Int']['input'];
  labelId?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
};

export type SaveProducerInput = {
  contactDetails: ContactDetailsInput;
  contacts?: Array<SaveContactInput>;
  name: Scalars['String']['input'];
};

export type SaveProjectInput = {
  access: ProjectAccess;
  clients?: InputMaybe<Array<Scalars['UUID']['input']>>;
  customFieldValues?: Array<CustomFieldValueInput>;
  deadline: TimestampInput;
  finalCost?: InputMaybe<Scalars['Float']['input']>;
  hasPriority?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  procedureProperties?: InputMaybe<ProcedurePropertiesInput>;
  producers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  projectTypeId: Scalars['UUID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<SaveResourceInput>>;
  responsibleId: Scalars['UUID']['input'];
  startDate: TimestampInput;
  targetCost?: InputMaybe<Scalars['Float']['input']>;
  teamContributors?: InputMaybe<Array<TeamContributorInput>>;
  timeFactorId?: InputMaybe<Scalars['UUID']['input']>;
  userContributors?: InputMaybe<Array<UserContributorInput>>;
};

export type SaveProjectMaterialInput = {
  additionalReferenceNumbers?: Array<AdditionalReferenceNumberInput>;
  consumption: Scalars['Float']['input'];
  consumptions?: InputMaybe<Array<ProjectMaterialConsumptionInput>>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  materialId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  orderReminder?: InputMaybe<TimestampInput>;
  ownerId: Scalars['UUID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  priceCurrency?: InputMaybe<Currency>;
  prices?: InputMaybe<Array<ProjectMaterialPriceInput>>;
  projectId: Scalars['UUID']['input'];
  sizeMatrixItemIds: Array<Scalars['UUID']['input']>;
  supplierId: Scalars['UUID']['input'];
  targetDeadline?: InputMaybe<TimestampInput>;
  targetDeadlineMilestoneId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SaveProjectTypeInput = {
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type SaveRecipientTeamInput = {
  sendEmail: Scalars['Boolean']['input'];
  teamId: Scalars['UUID']['input'];
};

export type SaveRecipientUserInput = {
  sendEmail: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};

export type SaveRecipientsInput = {
  teams?: Array<SaveRecipientTeamInput>;
  users?: Array<SaveRecipientUserInput>;
};

export type SaveRecurringDefinitionInput = {
  assignees?: InputMaybe<Array<Scalars['UUID']['input']>>;
  createDaysBeforeDeadline: Scalars['Int']['input'];
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  fashionCollectionItemId?: InputMaybe<Scalars['UUID']['input']>;
  followers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  goalId?: InputMaybe<Scalars['UUID']['input']>;
  milestoneId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  onDateOfYear?: InputMaybe<TimestampInput>;
  recurringEnd?: InputMaybe<TimestampInput>;
  recurringPeriod: RecurringPeriod;
  recurringPeriodInterval: Scalars['Int']['input'];
  startDate: TimestampInput;
  tasksConfig?: Array<RecurringTaskConfigInput>;
};

export type SaveResourceInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  commentId?: InputMaybe<Scalars['UUID']['input']>;
  goalId?: InputMaybe<Scalars['UUID']['input']>;
  isInline?: Scalars['Boolean']['input'];
  isLink?: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  milestoneId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  size?: InputMaybe<Scalars['Long']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SaveResourcesInput = {
  resources: Array<SaveResourceInput>;
};

export type SaveSectionInput = {
  boardId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type SaveSizeInput = {
  name: Scalars['String']['input'];
  sizeStandardId: Scalars['UUID']['input'];
};

export type SaveSizeMatrixInput = {
  items: Array<SizeMatrixItemInput>;
  name: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
  sizeStandardId: Scalars['UUID']['input'];
};

export type SaveSizeStandardInput = {
  name: Scalars['String']['input'];
  sizes: Array<Scalars['String']['input']>;
};

export type SaveStockRequestsInput = {
  items: Array<StockRequestItemInput>;
  materialsProductionRequestId: Scalars['UUID']['input'];
};

export type SaveSubTaskInput = {
  assignee: Scalars['UUID']['input'];
  deadline: TimestampInput;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  followers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  parentTaskId: Scalars['UUID']['input'];
  remindAt?: InputMaybe<TimestampInput>;
  resources?: InputMaybe<Array<SaveResourceInput>>;
  sendEmail?: Scalars['Boolean']['input'];
  teamFollowerIds?: Array<Scalars['UUID']['input']>;
};

export type SaveSupplierInput = {
  contactDetails: ContactDetailsInput;
  contacts?: Array<SaveContactInput>;
  currency: Currency;
  name: Scalars['String']['input'];
};

export type SaveTaskInput = {
  assignees?: InputMaybe<Array<Scalars['UUID']['input']>>;
  comment?: InputMaybe<FirstCommentInput>;
  customDuplicateTasks?: InputMaybe<Array<DuplicateTaskInput>>;
  deadline?: InputMaybe<TimestampInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailees?: InputMaybe<Array<Scalars['UUID']['input']>>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  fashionCollectionItemId?: InputMaybe<Scalars['UUID']['input']>;
  followers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  goalId?: InputMaybe<Scalars['UUID']['input']>;
  isStandby?: Scalars['Boolean']['input'];
  linkedEmail?: InputMaybe<LinkEntityToEmailLinkInput>;
  milestoneId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  remindAt?: InputMaybe<TimestampInput>;
  resources?: InputMaybe<Array<SaveResourceInput>>;
  teamFollowerIds?: Array<Scalars['UUID']['input']>;
};

export type SaveTaskReminderInput = {
  remindAt: TimestampInput;
  taskId: Scalars['UUID']['input'];
};

export type SaveTeamInput = {
  isGuest?: Scalars['Boolean']['input'];
  members: Array<TeamMemberInput>;
  name: Scalars['String']['input'];
  teamLeadId: Scalars['UUID']['input'];
};

export type SaveThreadDraftInput = {
  labelIds?: Array<Scalars['UUID']['input']>;
  resources?: Array<SaveResourceInput>;
  teamRecipients?: Array<Scalars['UUID']['input']>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userRecipients?: Array<Scalars['UUID']['input']>;
};

export type SaveThreadInput = {
  comment: SaveCommentInput;
  draftId?: InputMaybe<Scalars['UUID']['input']>;
  draftResourceIds?: Array<Scalars['UUID']['input']>;
  labelIds?: Array<Scalars['UUID']['input']>;
  remindAt?: InputMaybe<TimestampInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveTimeFactorInput = {
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type SaveTranslationInput = {
  key: Scalars['String']['input'];
  language: Language;
  value: Scalars['String']['input'];
};

export type SaveTranslationNoteInput = {
  key: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type SaveWarehouseInput = {
  addressId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SaveWorkCalendarExceptionPeriodInput = {
  endDate: TimestampInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate: TimestampInput;
  type: WorkCalendarExceptionPeriodType;
};

export type SearchBoardsInput = {
  filters?: Array<BoardFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<BoardSorterInput>;
};

export type SearchClientsFilterInput = {
  field: ClientsField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type SearchClientsInput = {
  filters?: InputMaybe<Array<SearchClientsFilterInput>>;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<SearchClientsSorterInput>>;
};

export type SearchClientsSorterInput = {
  direction: SortDirection;
  field: ClientsField;
};

export type SearchCommentsInput = {
  filters?: Array<Array<CommentFilterInput>>;
  pageRequest: PageRequestInput;
  sorters?: Array<CommentSorterInput>;
};

export type SearchFashionCollectionItemsInput = {
  filters?: Array<Array<FashionCollectionItemFilterInput>>;
  pageRequest: PageRequestInput;
  sorters?: Array<FashionCollectionItemSorterInput>;
};

export type SearchFashionCollectionLabelsInput = {
  filters?: InputMaybe<Array<FashionCollectionLabelFilterInput>>;
  pageRequest: PageRequestInput;
  sorters?: InputMaybe<Array<FashionCollectionLabelSorterInput>>;
};

export type SearchFashionCollectionsInput = {
  filters: Array<FashionCollectionFilterInput>;
  pageRequest: PageRequestInput;
  sorters: Array<FashionCollectionSorterInput>;
};

export type SearchGoalsInput = {
  filters?: Array<Array<GoalFilterInput>>;
  pageRequest: PageRequestInput;
  sorters?: Array<GoalSorterInput>;
};

export type SearchLabelsFilterInput = {
  field: LabelField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type SearchLabelsInput = {
  filters?: InputMaybe<Array<SearchLabelsFilterInput>>;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<SearchLabelsSorterInput>>;
};

export type SearchLabelsSorterInput = {
  direction: SortDirection;
  field: LabelField;
};

export type SearchMaterialsInput = {
  filters?: Array<MaterialFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<MaterialSorterInput>;
};

export type SearchMaterialsProductionRequestsInput = {
  filters?: Array<MaterialsProductionRequestFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<MaterialsProductionRequestSorterInput>;
};

export type SearchMilestonesInput = {
  filters?: InputMaybe<Array<Array<MilestoneFilterInput>>>;
  includeServiceMilestones?: Scalars['Boolean']['input'];
  pageRequest: PageRequestInput;
  projectCustomFieldFilters?: Array<CustomFieldFilterInput>;
  projectCustomFieldSorter?: InputMaybe<CustomFieldSorterInput>;
  sorters?: InputMaybe<Array<MilestoneSorterInput>>;
};

export type SearchNomenclatureInput = {
  filters?: Array<NomenclatureFilterInput>;
  pageRequest?: PageRequestInput;
  sorters?: Array<NomenclatureSorterInput>;
};

export type SearchNotificationsInput = {
  filters?: InputMaybe<Array<NotificationFilterInput>>;
  pageRequest: PageRequestInput;
  sorters?: InputMaybe<Array<NotificationSorterInput>>;
};

export type SearchOrderInput = {
  filters?: Array<OrderFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<OrderSorterInput>;
};

export enum SearchProceduresField {
  IsActive = 'IS_ACTIVE',
  Name = 'NAME',
  Notes = 'NOTES'
}

export type SearchProceduresFilterInput = {
  field: SearchProceduresField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type SearchProceduresInput = {
  filters?: InputMaybe<Array<SearchProceduresFilterInput>>;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<SearchProceduresSorterInput>>;
};

export type SearchProceduresSorterInput = {
  direction: SortDirection;
  field: SearchProceduresField;
};

export type SearchProducersFilterInput = {
  field: ProducersField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type SearchProducersInput = {
  filters?: InputMaybe<Array<SearchProducersFilterInput>>;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<SearchProducersSorterInput>>;
};

export type SearchProducersSorterInput = {
  direction: SortDirection;
  field: ProducersField;
};

export type SearchProjectMaterialFilterInput = {
  field: ProjectMaterialField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type SearchProjectMaterialSorterInput = {
  direction: SortDirection;
  field: ProjectMaterialField;
};

export type SearchProjectMaterialsInput = {
  filters?: Array<SearchProjectMaterialFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<SearchProjectMaterialSorterInput>;
};

export type SearchProjectsInput = {
  customFieldFilters?: Array<CustomFieldFilterInput>;
  customFieldSorter?: InputMaybe<CustomFieldSorterInput>;
  filters?: InputMaybe<Array<Array<ProjectFilterInput>>>;
  milestoneDateFilters?: Array<MilestoneDateFilterInput>;
  milestoneSorter?: InputMaybe<BaseMilestoneSorterInput>;
  pageRequest: PageRequestInput;
  sorters?: InputMaybe<Array<ProjectSorterInput>>;
};

export type SearchResourceInput = {
  filters?: InputMaybe<Array<Array<ResourceFilterInput>>>;
  pageRequest: PageRequestInput;
  sorters?: InputMaybe<Array<ResourceSorterInput>>;
};

export type SearchSizeMatricesInput = {
  filters?: Array<SizeMatrixFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<SizeMatrixSorterInput>;
};

export type SearchTeamsFilterInput = {
  field: TeamField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type SearchTeamsInput = {
  filters?: InputMaybe<Array<SearchTeamsFilterInput>>;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<SearchTeamsSorterInput>>;
};

export type SearchTeamsSetFiltersInput = {
  field: TeamField;
  filters?: InputMaybe<Array<SearchTeamsFilterInput>>;
};

export type SearchTeamsSorterInput = {
  direction: SortDirection;
  field: TeamField;
};

export type SearchThreadsInput = {
  filters?: Array<ThreadFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<ThreadSorterInput>;
};

export type SearchTransactionDocumentsInput = {
  filters?: Array<TransactionDocumentFilterInput>;
  pageRequest: PageRequestInput;
};

export type SearchTransactionsInput = {
  filters?: Array<TransactionFilterInput>;
  pageRequest: PageRequestInput;
  sorters?: Array<TransactionSorterInput>;
};

export type SearchWarehouseMaterialInventoriesInput = {
  filters?: Array<WarehouseMaterialInventoryFilterInput>;
  pageRequest: PageRequestInput;
};

export type Section = {
  __typename?: 'Section';
  board: Board;
  goals: Array<Goal>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type SelectedColumns = {
  customField?: InputMaybe<Scalars['String']['input']>;
  projectField?: InputMaybe<ProjectField>;
};

export type SendInvitationInput = {
  email: Scalars['String']['input'];
  havelockEnabled: Scalars['Boolean']['input'];
  jobTitleId?: InputMaybe<Scalars['UUID']['input']>;
  prodactiveEnabled: Scalars['Boolean']['input'];
  roles: Array<Scalars['UUID']['input']>;
};

export type SetAccountActiveInput = {
  active: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};

export type SetFilter = {
  __typename?: 'SetFilter';
  id: Scalars['UUID']['output'];
  value: Scalars['String']['output'];
};

export type SetFilterResponse = {
  __typename?: 'SetFilterResponse';
  values: Array<SetFilter>;
};

export type SetProjectMaterialsDeadlineInput = {
  projectId: Scalars['UUID']['input'];
  targetDeadline?: InputMaybe<TimestampInput>;
  targetDeadlineMilestoneId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SetProjectReminderInput = {
  projectId: Scalars['UUID']['input'];
  remindAt?: InputMaybe<TimestampInput>;
};

export type Size = {
  __typename?: 'Size';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SizeMatrices = {
  __typename?: 'SizeMatrices';
  meta: Metadata;
  sizeMatrices: Array<SizeMatrix>;
};

export type SizeMatricesSetFilterInput = {
  field: SizeMatrixField;
  filters?: Array<SizeMatrixFilterInput>;
};

export type SizeMatrix = {
  __typename?: 'SizeMatrix';
  createdAt: Timestamp;
  id: Scalars['UUID']['output'];
  items: Array<SizeMatrixItem>;
  name: Scalars['String']['output'];
  project: Project;
  quantity: Scalars['Int']['output'];
  sizeStandard: SizeStandard;
  status: Status;
};

export type SizeMatrixEvent = Event & {
  __typename?: 'SizeMatrixEvent';
  sizeMatrix: SizeMatrix;
  type: EventType;
};

export enum SizeMatrixField {
  Clients = 'CLIENTS',
  CreatedOn = 'CREATED_ON',
  Name = 'NAME',
  Project = 'PROJECT',
  ProjectType = 'PROJECT_TYPE',
  Providers = 'PROVIDERS',
  Responsible = 'RESPONSIBLE',
  SizeStandard = 'SIZE_STANDARD',
  Status = 'STATUS',
  TimeFactor = 'TIME_FACTOR'
}

export type SizeMatrixFilterInput = {
  field: SizeMatrixField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type SizeMatrixItem = {
  __typename?: 'SizeMatrixItem';
  id: Scalars['UUID']['output'];
  quantity: Scalars['Int']['output'];
  size: Size;
  sizeMatrix: SizeMatrix;
};

export type SizeMatrixItemInput = {
  quantity: Scalars['Int']['input'];
  sizeId: Scalars['UUID']['input'];
};

export type SizeMatrixSorterInput = {
  direction: SortDirection;
  field: SizeMatrixField;
};

export type SizeStandard = {
  __typename?: 'SizeStandard';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sizes: Array<Size>;
};

export type SizeStandards = {
  __typename?: 'SizeStandards';
  meta: Metadata;
  sizeStandards: Array<SizeStandard>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Status {
  Canceled = 'CANCELED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export type StockRequest = {
  __typename?: 'StockRequest';
  checkoutTransaction?: Maybe<Transaction>;
  id: Scalars['UUID']['output'];
  materials: Array<StockRequestMaterial>;
  warehouse: Warehouse;
};

export type StockRequestItemInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  materialId: Scalars['UUID']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  quantity: Scalars['Int']['input'];
  warehouseId: Scalars['UUID']['input'];
};

export type StockRequestMaterial = {
  __typename?: 'StockRequestMaterial';
  client?: Maybe<Client>;
  material: Material;
  project?: Maybe<Project>;
  quantity: Scalars['Int']['output'];
};

export type StringValue = {
  __typename?: 'StringValue';
  value: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  accounts?: Maybe<AccountEvent>;
  activityLog?: Maybe<LogEntry>;
  assignedGoals: GoalEventUnion;
  board: BoardEventUnion;
  boards: BoardEventUnion;
  comments: CommentEventUnion;
  commentsRead: CommentsReadEvent;
  counter?: Maybe<CountEvent>;
  dynamicReminders: DynamicPlanningEventUnion;
  fashionCollection: FashionCollectionEventUnion;
  fashionCollections: FashionCollectionEventUnion;
  goal: GoalEventUnion;
  goalTasks: TaskEventUnion;
  milestoneTasks: TaskEventUnion;
  myTasks: TaskEventUnion;
  notifications?: Maybe<Notification>;
  notificationsCounter: Scalars['Long']['output'];
  project: ProjectEventUnion;
  projectMilestones: MilestoneEventUnion;
  projectSizeMatrix: SizeMatrixEvent;
  projects: ProjectEventUnion;
  recurringDefinition: RecurringDefinitionEvent;
  recurringDefinitionTasks: TaskEventUnion;
  resources: ResourceEventUnion;
  sizeMatrices: SizeMatrixEvent;
  taskTree: TaskEventUnion;
  threadComments: ThreadCommentEvent;
  threadLikes: ThreadLikeEvent;
  threadNotification: EmptyResponse;
  userTaskCounter?: Maybe<TaskCounters>;
  userTodoCounter?: Maybe<TaskCounters>;
};


export type SubscriptionActivityLogArgs = {
  entityId: Scalars['UUID']['input'];
};


export type SubscriptionBoardArgs = {
  boardId: Scalars['UUID']['input'];
};


export type SubscriptionCommentsArgs = {
  entityId: Scalars['UUID']['input'];
  type: CommentEntityType;
};


export type SubscriptionCommentsReadArgs = {
  entityId: Scalars['UUID']['input'];
};


export type SubscriptionCounterArgs = {
  counterType: CounterType;
  entityId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionFashionCollectionArgs = {
  collectionId: Scalars['UUID']['input'];
};


export type SubscriptionGoalArgs = {
  goalId: Scalars['UUID']['input'];
};


export type SubscriptionGoalTasksArgs = {
  goalId: Scalars['UUID']['input'];
};


export type SubscriptionMilestoneTasksArgs = {
  milestoneId: Scalars['UUID']['input'];
};


export type SubscriptionProjectArgs = {
  projectId: Scalars['UUID']['input'];
};


export type SubscriptionProjectMilestonesArgs = {
  projectId: Scalars['UUID']['input'];
};


export type SubscriptionProjectSizeMatrixArgs = {
  projectId: Scalars['UUID']['input'];
};


export type SubscriptionRecurringDefinitionArgs = {
  recurringDefinitionId: Scalars['UUID']['input'];
};


export type SubscriptionRecurringDefinitionTasksArgs = {
  recurringDefinitionId: Scalars['UUID']['input'];
};


export type SubscriptionResourcesArgs = {
  entityId: Scalars['UUID']['input'];
  type: ContextType;
};


export type SubscriptionTaskTreeArgs = {
  rootTaskId: Scalars['UUID']['input'];
};

export type Supplier = {
  __typename?: 'Supplier';
  contactDetails: ContactDetails;
  contacts: Array<Contact>;
  currency: Currency;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Suppliers = {
  __typename?: 'Suppliers';
  meta: Metadata;
  suppliers?: Maybe<Array<Supplier>>;
};

export enum Table {
  Project = 'PROJECT'
}

export type Task = {
  __typename?: 'Task';
  allowedStatuses: Array<Status>;
  assignees?: Maybe<Array<Account>>;
  comments?: Maybe<Array<Comment>>;
  commentsState?: Maybe<CommentsState>;
  createdAt: Timestamp;
  createdBy: Account;
  deadline?: Maybe<Timestamp>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  executionDate?: Maybe<Timestamp>;
  fashionCollectionItem?: Maybe<FashionCollectionItem>;
  followers: Array<Account>;
  goal?: Maybe<Goal>;
  id: Scalars['UUID']['output'];
  isRecurringDefinition: Scalars['Boolean']['output'];
  isStandby: Scalars['Boolean']['output'];
  loggedHours?: Maybe<Scalars['Float']['output']>;
  milestone?: Maybe<Milestone>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Account>;
  parentEntityType?: Maybe<TaskParentEntityType>;
  parentTaskId?: Maybe<Scalars['UUID']['output']>;
  project?: Maybe<Project>;
  recurringId?: Maybe<Scalars['UUID']['output']>;
  remindMe?: Maybe<Timestamp>;
  resources: Array<Resource>;
  rootTaskId?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskTree: Array<Task>;
  teamFollowers: Array<Team>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TaskAssigneeInput = {
  deadline?: InputMaybe<TimestampInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TaskCounters = {
  __typename?: 'TaskCounters';
  assignedByMe: Scalars['Int']['output'];
  assignedToMe: Scalars['Int']['output'];
  following: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TaskDeletedLogEntry = {
  __typename?: 'TaskDeletedLogEntry';
  assignee: Account;
  name: Scalars['String']['output'];
};

export type TaskDetailsCounters = {
  __typename?: 'TaskDetailsCounters';
  commentsCount: Scalars['Int']['output'];
  resourcesCount: Scalars['Int']['output'];
  taskId: Scalars['UUID']['output'];
  tasksCount: Scalars['Int']['output'];
};

export type TaskDirectSourceFilter = {
  __typename?: 'TaskDirectSourceFilter';
  id: Scalars['UUID']['output'];
  type: TaskDirectSourceType;
  value: Scalars['String']['output'];
};

export type TaskDirectSourceFilterInput = {
  ids: Array<Scalars['UUID']['input']>;
  type: TaskDirectSourceType;
};

export enum TaskDirectSourceType {
  BaseMilestone = 'BASE_MILESTONE',
  Goal = 'GOAL',
  Milestone = 'MILESTONE'
}

export type TaskEvent = Event & {
  __typename?: 'TaskEvent';
  deletedStandbyTaskId?: Maybe<Scalars['UUID']['output']>;
  task: Task;
  taskTree: Array<Task>;
  type: EventType;
};

export type TaskEventUnion = EntityDeletedEvent | TaskEvent;

export enum TaskField {
  AssignedTo = 'ASSIGNED_TO',
  BaseSource = 'BASE_SOURCE',
  Boards = 'BOARDS',
  Clients = 'CLIENTS',
  Deadline = 'DEADLINE',
  DirectSource = 'DIRECT_SOURCE',
  ExecutionDate = 'EXECUTION_DATE',
  FashionCollectionItem = 'FASHION_COLLECTION_ITEM',
  Followers = 'FOLLOWERS',
  HasPriority = 'HAS_PRIORITY',
  Name = 'NAME',
  Owner = 'OWNER',
  Project = 'PROJECT',
  ProjectType = 'PROJECT_TYPE',
  Providers = 'PROVIDERS',
  Reference = 'REFERENCE',
  RemindMe = 'REMIND_ME',
  Status = 'STATUS',
  TimeFactor = 'TIME_FACTOR',
  Type = 'TYPE'
}

export type TaskFilterInput = {
  field: TaskField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type TaskFollowerActionInput = {
  followerId: Scalars['UUID']['input'];
  taskId: Scalars['UUID']['input'];
};

export enum TaskParentEntityType {
  FashionCollectionItem = 'FASHION_COLLECTION_ITEM',
  Goal = 'GOAL',
  Milestone = 'MILESTONE'
}

export type TaskSorterInput = {
  direction: SortDirection;
  field: TaskField;
};

export type Tasks = {
  __typename?: 'Tasks';
  meta?: Maybe<Metadata>;
  tasks?: Maybe<Array<Task>>;
};

export type TasksMetadata = {
  __typename?: 'TasksMetadata';
  tasksCanceled?: Maybe<Scalars['Int']['output']>;
  tasksCount?: Maybe<Scalars['Int']['output']>;
  tasksDone?: Maybe<Scalars['Int']['output']>;
};

export type TasksReportInput = {
  directSourceFilters?: Array<TaskDirectSourceFilterInput>;
  filters?: Array<Array<TaskFilterInput>>;
  isTodos?: InputMaybe<Scalars['Boolean']['input']>;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<TaskSorterInput>>;
};

export type TasksReportSetFiltersInput = {
  directSourceFilters?: Array<TaskDirectSourceFilterInput>;
  field: TaskField;
  filters?: Array<Array<TaskFilterInput>>;
  isTodos?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Team = {
  __typename?: 'Team';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isGuest: Scalars['Boolean']['output'];
  isLockedForUpdate: Scalars['Boolean']['output'];
  members: Array<TeamMember>;
  name: Scalars['String']['output'];
  teamLead: Account;
};

export type TeamContributor = {
  __typename?: 'TeamContributor';
  contributors: Array<UserContributor>;
  team: Team;
};

export type TeamContributorInput = {
  contributors: Array<UserContributorInput>;
  teamId: Scalars['UUID']['input'];
};

export enum TeamField {
  Guests = 'GUESTS',
  IsActive = 'IS_ACTIVE',
  Members = 'MEMBERS',
  Name = 'NAME',
  TeamLead = 'TEAM_LEAD'
}

export type TeamMember = {
  __typename?: 'TeamMember';
  account: Account;
  isGuest?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamMemberActivity = {
  __typename?: 'TeamMemberActivity';
  goals: MemberGoals;
  tasks: MemberTasks;
  teamMember: TeamMember;
};

export type TeamMemberInput = {
  accountId: Scalars['UUID']['input'];
  isGuest?: Scalars['Boolean']['input'];
};

export type Teams = {
  __typename?: 'Teams';
  meta: Metadata;
  teams: Array<Team>;
};

export type Thread = {
  __typename?: 'Thread';
  alias?: Maybe<Scalars['String']['output']>;
  comments: Array<Comment>;
  convertedToGoal?: Maybe<Goal>;
  convertedToTask?: Maybe<Task>;
  createdAt: Timestamp;
  createdBy: Account;
  id: Scalars['UUID']['output'];
  isFavourite: Scalars['Boolean']['output'];
  labels: Array<Label>;
  lastReadTime?: Maybe<Timestamp>;
  participants: ThreadParticipants;
  remindAt?: Maybe<Timestamp>;
  title: Scalars['String']['output'];
  unreadCommentCount: Scalars['Int']['output'];
  unreadComments: Scalars['Boolean']['output'];
};


export type ThreadCommentsArgs = {
  pageRequest: PageRequestInput;
};

export type ThreadActivities = {
  __typename?: 'ThreadActivities';
  activities: Array<ThreadActivity>;
  meta: Metadata;
};

export type ThreadActivity = ThreadCommentActivity | ThreadGoalActivity | ThreadLikeActivity | ThreadTaskActivity;

export type ThreadCommentActivity = {
  __typename?: 'ThreadCommentActivity';
  lastParticipant: Account;
  recentParticipants: Array<Account>;
  thread: Thread;
  time: Timestamp;
};

export type ThreadCommentEvent = {
  __typename?: 'ThreadCommentEvent';
  author: Account;
  createdGoal?: Maybe<Goal>;
  createdTask?: Maybe<Task>;
  isTerminal?: Maybe<Scalars['Boolean']['output']>;
  isUserNotified: Scalars['Boolean']['output'];
  thread: Thread;
  time: Timestamp;
};

export type ThreadCounters = {
  __typename?: 'ThreadCounters';
  drafts: Scalars['Int']['output'];
  favourites: Scalars['Int']['output'];
  reminders: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
};

export type ThreadDraft = {
  __typename?: 'ThreadDraft';
  createdAt: Timestamp;
  id: Scalars['UUID']['output'];
  labels: Array<Label>;
  resources: Array<Resource>;
  teamRecipients: Array<Team>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  userRecipients: Array<Account>;
};

export enum ThreadField {
  CommentText = 'COMMENT_TEXT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  IsRead = 'IS_READ',
  Labels = 'LABELS',
  Participants = 'PARTICIPANTS',
  RemindAt = 'REMIND_AT',
  Title = 'TITLE'
}

export type ThreadFilterInput = {
  field: ThreadField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type ThreadGoalActivity = {
  __typename?: 'ThreadGoalActivity';
  convertedBy: Account;
  createdAt: Timestamp;
  goal?: Maybe<Goal>;
  isTerminal: Scalars['Boolean']['output'];
  thread: Thread;
};

export type ThreadLikeActivity = {
  __typename?: 'ThreadLikeActivity';
  accounts: Array<Account>;
  comment: Comment;
  time: Timestamp;
};

export type ThreadLikeEvent = {
  __typename?: 'ThreadLikeEvent';
  author: Account;
  comment: Comment;
  time?: Maybe<Timestamp>;
};

export type ThreadParticipants = {
  __typename?: 'ThreadParticipants';
  teams: Array<Team>;
  users: Array<Account>;
};

export type ThreadSorterInput = {
  direction: SortDirection;
  field: ThreadField;
};

export type ThreadTaskActivity = {
  __typename?: 'ThreadTaskActivity';
  convertedBy: Account;
  createdAt: Timestamp;
  isTerminal: Scalars['Boolean']['output'];
  task?: Maybe<Task>;
  thread: Thread;
};

export type Threads = {
  __typename?: 'Threads';
  meta: Metadata;
  threads: Array<Thread>;
};

export type ThreadsSetFilterInput = {
  field: ThreadField;
  filters?: Array<ThreadFilterInput>;
};

export type TimeFactor = {
  __typename?: 'TimeFactor';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type TimeFactors = {
  __typename?: 'TimeFactors';
  meta: Metadata;
  timeFactorsList?: Maybe<Array<TimeFactor>>;
};

export enum TimeTrackingField {
  Amount = 'AMOUNT',
  LoggedHours = 'LOGGED_HOURS',
  LoggedHoursBillable = 'LOGGED_HOURS_BILLABLE',
  LoggedHoursNonBillable = 'LOGGED_HOURS_NON_BILLABLE',
  TotalEstimatedHours = 'TOTAL_ESTIMATED_HOURS',
  TotalLoggedHours = 'TOTAL_LOGGED_HOURS'
}

export type TimeTrackingReport = {
  __typename?: 'TimeTrackingReport';
  meta: Metadata;
  rows?: Maybe<Array<TimeTrackingReportRow>>;
};

export type TimeTrackingReportFilterInput = {
  field: TaskField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type TimeTrackingReportInput = {
  filters?: InputMaybe<Array<TimeTrackingReportFilterInput>>;
  from: TimestampInput;
  pageRequest?: InputMaybe<PageRequestInput>;
  sorters?: InputMaybe<Array<TimeTrackingReportSorterInput>>;
  to: TimestampInput;
};

export type TimeTrackingReportRow = {
  __typename?: 'TimeTrackingReportRow';
  loggedTimes?: Maybe<Array<LoggedTime>>;
  task: Task;
};

export type TimeTrackingReportSetFilterInput = {
  field: TaskField;
  filters?: InputMaybe<Array<TimeTrackingReportFilterInput>>;
  from: TimestampInput;
  to: TimestampInput;
};

export type TimeTrackingReportSorterInput = {
  direction: SortDirection;
  field: TaskField;
};

export type TimeTrackingReportTotals = {
  __typename?: 'TimeTrackingReportTotals';
  amount: Scalars['Float']['output'];
  billable: Scalars['Float']['output'];
  nonBillable: Scalars['Float']['output'];
  totalEstimate: Scalars['Float']['output'];
  totalLogged: Scalars['Float']['output'];
};

/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 */
export type Timestamp = {
  __typename?: 'Timestamp';
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999
   * inclusive.
   */
  nanos?: Maybe<Scalars['Long']['output']>;
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   */
  seconds?: Maybe<Scalars['Long']['output']>;
};

/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 */
export type TimestampInput = {
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999
   * inclusive.
   */
  nanos?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   */
  seconds: Scalars['Int']['input'];
};

export type TrackedActivity = {
  __typename?: 'TrackedActivity';
  baseMilestone: BaseMilestone;
  color: Scalars['String']['output'];
  shouldNotifyForDateChange: Scalars['Boolean']['output'];
};

export type TrackedActivityInput = {
  baseMilestoneId: Scalars['UUID']['input'];
  color: Scalars['String']['input'];
  shouldNotifyForDateChange?: Scalars['Boolean']['input'];
};

export type Transaction = {
  __typename?: 'Transaction';
  createdAt: Timestamp;
  createdBy: Account;
  fromWarehouse?: Maybe<Warehouse>;
  id: Scalars['UUID']['output'];
  materials: Array<TransactionMaterial>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  toWarehouse?: Maybe<Warehouse>;
  type: TransactionType;
};

export type TransactionDocument = {
  __typename?: 'TransactionDocument';
  date: Timestamp;
  number: Scalars['Int']['output'];
  resource: Resource;
  transaction: Transaction;
  type: TransactionDocumentType;
};

export enum TransactionDocumentField {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DocumentDate = 'DOCUMENT_DATE',
  DocumentNumber = 'DOCUMENT_NUMBER',
  DocumentType = 'DOCUMENT_TYPE',
  Filename = 'FILENAME',
  Material = 'MATERIAL',
  Transaction = 'TRANSACTION',
  TransactionType = 'TRANSACTION_TYPE'
}

export type TransactionDocumentFilterInput = {
  field: TransactionDocumentField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type TransactionDocumentInput = {
  date: TimestampInput;
  resource: SaveResourceInput;
  type: TransactionDocumentType;
};

export enum TransactionDocumentType {
  Invoice = 'INVOICE',
  Other = 'OTHER',
  PackingList = 'PACKING_LIST',
  StockRequest = 'STOCK_REQUEST'
}

export type TransactionDocuments = {
  __typename?: 'TransactionDocuments';
  documents: Array<TransactionDocument>;
  meta: Metadata;
};

export type TransactionDocumentsSetFiltersInput = {
  field: TransactionDocumentField;
  filters?: Array<TransactionDocumentFilterInput>;
};

export enum TransactionField {
  CreatedBy = 'CREATED_BY',
  FromClient = 'FROM_CLIENT',
  FromWarehouse = 'FROM_WAREHOUSE',
  Number = 'NUMBER',
  ToClient = 'TO_CLIENT',
  ToWarehouse = 'TO_WAREHOUSE',
  Type = 'TYPE'
}

export type TransactionFilterInput = {
  field: TransactionField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export type TransactionMaterial = {
  __typename?: 'TransactionMaterial';
  fromClient?: Maybe<Client>;
  fromProject?: Maybe<Project>;
  material: Material;
  quantity: Scalars['Int']['output'];
  toClient?: Maybe<Client>;
  toProject?: Maybe<Project>;
};

export type TransactionSorterInput = {
  direction: SortDirection;
  field: TransactionField;
};

export enum TransactionType {
  Adjustment = 'ADJUSTMENT',
  Checkin = 'CHECKIN',
  Checkout = 'CHECKOUT',
  Reserve = 'RESERVE',
  Transfer = 'TRANSFER',
  Unreserve = 'UNRESERVE'
}

export type Transactions = {
  __typename?: 'Transactions';
  meta: Metadata;
  transactions: Array<Transaction>;
};

export type TransactionsSetFiltersInput = {
  field: TransactionField;
  filters?: Array<TransactionFilterInput>;
};

export type TransferMaterialsInput = {
  documents?: Array<TransactionDocumentInput>;
  fromWarehouseId: Scalars['UUID']['input'];
  materials: Array<TransferTransactionMaterialInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  toWarehouseId: Scalars['UUID']['input'];
};

export type TransferTransactionMaterialInput = {
  fromClientId?: InputMaybe<Scalars['UUID']['input']>;
  materialId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
  toClientId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TransformStandbyToRecurringInput = {
  recurringDefinitionInput: SaveRecurringDefinitionInput;
  standbyTaskId: Scalars['UUID']['input'];
};

export type Translation = {
  __typename?: 'Translation';
  key: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type Translations = {
  __typename?: 'Translations';
  language: Language;
  translations: Array<Translation>;
};

export type UpdateAccountInput = {
  datePreferences?: InputMaybe<Scalars['OptionalString']['input']>;
  firstName: Scalars['String']['input'];
  googleCalendarAuthorizationCode?: InputMaybe<Scalars['String']['input']>;
  googleCalendarIds?: InputMaybe<Array<Scalars['String']['input']>>;
  havelockEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  isGoogleCalendarEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOutlookCalendarEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleId?: InputMaybe<Scalars['OptionalUUID']['input']>;
  keyMilestonesSettings?: InputMaybe<MilestonesSettingsInput>;
  lang: Language;
  lastName: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['OptionalString']['input']>;
  outlookCalendarAuthorizationCode?: InputMaybe<Scalars['String']['input']>;
  outlookCalendarIds?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  playThreadNotificationSound?: InputMaybe<Scalars['Boolean']['input']>;
  prodactiveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  productionPlanningSettings?: InputMaybe<MilestonesSettingsInput>;
  profileImage?: InputMaybe<SaveResourceInput>;
  roles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  showOnlyNewThreadsActivity?: InputMaybe<Scalars['Boolean']['input']>;
  teams?: InputMaybe<Array<Scalars['UUID']['input']>>;
  timezone: Scalars['String']['input'];
  widgets?: InputMaybe<Array<Widget>>;
};

export type UpdateAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssignedProducerInput = {
  endDate: TimestampInput;
  id: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfWorkers?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['UUID']['input']>;
  productionTime?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  startDate: TimestampInput;
  status: ProductionPlanningStatus;
};

export type UpdateBaseMilestoneInput = {
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateBoardInput = {
  access?: InputMaybe<UpdateContributorsAccessInput>;
  id: Scalars['UUID']['input'];
  isArchived: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ownerId: Scalars['UUID']['input'];
  sectionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateBoardUserSettingsInput = {
  id: Scalars['UUID']['input'];
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  showCompletedGoals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCategoryInput = {
  id: Scalars['UUID']['input'];
  isActive?: Scalars['Boolean']['input'];
  isDefaultType?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateClientInput = {
  contactDetails: ContactDetailsInput;
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCommentInput = {
  deadlineRequest?: InputMaybe<DeadlineRequestInput>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  onBehalfOfId?: InputMaybe<Scalars['UUID']['input']>;
  recipients: SaveRecipientsInput;
  resources?: InputMaybe<Array<SaveResourceInput>>;
  text: Scalars['String']['input'];
};

export type UpdateContactInput = {
  contactDetails: ContactDetailsInput;
  firstName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
};

export type UpdateContributorsAccessInput = {
  teamContributors: Array<TeamContributorInput>;
  userContributors: Array<UserContributorInput>;
};

export type UpdateCustomFieldDefinitionInput = {
  contributors: UpdateContributorsAccessInput;
  description?: InputMaybe<Scalars['OptionalString']['input']>;
  enumEntries?: Array<EnumEntryUpdateInput>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tooltip?: InputMaybe<Scalars['OptionalString']['input']>;
};

export type UpdateEmailAccountInput = {
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['OptionalString']['input']>;
  newEmailSignatureId?: InputMaybe<Scalars['OptionalUUID']['input']>;
  otherAccountIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  replySignatureId?: InputMaybe<Scalars['OptionalUUID']['input']>;
};

export type UpdateFashionCollectionAccessInput = {
  teamContributors?: Array<TeamContributorInput>;
  userContributors?: Array<UserContributorInput>;
};

export type UpdateFashionCollectionInput = {
  access?: InputMaybe<UpdateContributorsAccessInput>;
  id: Scalars['UUID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  sectionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateFashionCollectionItemInput = {
  id: Scalars['UUID']['input'];
  labelIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  resources?: InputMaybe<Array<ModifyResourceInput>>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFashionCollectionLabelInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFashionCollectionSectionInput = {
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGoalInput = {
  assigneeId?: InputMaybe<Scalars['OptionalUUID']['input']>;
  deadline?: InputMaybe<OptionalTimestampInput>;
  executionDate?: InputMaybe<TimestampInput>;
  followerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id: Scalars['UUID']['input'];
  labelIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['OptionalString']['input']>;
  ownerId: Scalars['UUID']['input'];
  projectIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  remindMe?: InputMaybe<TimestampInput>;
  status: Status;
  teamFollowerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateImapAccountInput = {
  id: Scalars['UUID']['input'];
  imapHost?: InputMaybe<Scalars['String']['input']>;
  imapPassword?: InputMaybe<Scalars['String']['input']>;
  imapPort?: InputMaybe<Scalars['Int']['input']>;
  smtpHost?: InputMaybe<Scalars['String']['input']>;
  smtpPort?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateJobTitleInput = {
  application?: InputMaybe<Application>;
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateLabelInput = {
  color: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateLoggedTimeInput = {
  hours: Scalars['Float']['input'];
  id: Scalars['UUID']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  time: TimestampInput;
};

export type UpdateManufacturerInput = {
  contactDetails?: InputMaybe<ContactDetailsInput>;
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMaterialInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  deleteImage?: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
  image?: InputMaybe<SaveResourceInput>;
  isInProduction?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  manufacturerId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceCurrency?: InputMaybe<Currency>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateMaterialTypeInput = {
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMaterialsProductionRequestInput = {
  id: Scalars['UUID']['input'];
  items?: InputMaybe<Array<MaterialsProductionRequestItemInput>>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  productionNotes?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<TimestampInput>;
  status?: InputMaybe<MaterialsProductionRequestStatus>;
  warehouseNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMilestoneInput = {
  adjustedDuration?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  dynamicPlanner?: InputMaybe<OptionalTimestampInput>;
  executionDate?: InputMaybe<OptionalTimestampInput>;
  id: Scalars['UUID']['input'];
  isDeadlineLocked?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['OptionalUUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['OptionalString']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  targetDeadline?: InputMaybe<OptionalTimestampInput>;
};

export type UpdateOrderInput = {
  actualDeliveryDate?: InputMaybe<TimestampInput>;
  billingAddressId?: InputMaybe<Scalars['UUID']['input']>;
  confirmedDeliveryDate?: InputMaybe<TimestampInput>;
  id: Scalars['UUID']['input'];
  isCanceled?: Scalars['Boolean']['input'];
  isDraft?: Scalars['Boolean']['input'];
  materialStatuses?: InputMaybe<Array<OrderMaterialStatusInput>>;
  materials?: InputMaybe<Array<OrderMaterialInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<TimestampInput>;
  requestedDeliveryDate?: InputMaybe<TimestampInput>;
  requesterAddressId?: InputMaybe<Scalars['UUID']['input']>;
  shippingAddressId?: InputMaybe<Scalars['UUID']['input']>;
  shippingTerms?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['UUID']['input']>;
  supplierNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  currency: Currency;
  language: Language;
  logo?: InputMaybe<SaveResourceInput>;
  name: Scalars['String']['input'];
  workDayHours: Scalars['Int']['input'];
  workDays: Array<DayOfWeek>;
};

export type UpdateOrganizationInternalInput = {
  currency: Currency;
  features?: Array<Feature>;
  havelockEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  industry?: InputMaybe<OrganizationIndustry>;
  isActive: Scalars['Boolean']['input'];
  language: Language;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  prodactiveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<OrganizationType>;
};

export type UpdateProcedureInput = {
  clientIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  hasPriority?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  image?: InputMaybe<SaveResourceInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['OptionalString']['input']>;
  producerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  projectNotes?: InputMaybe<Scalars['OptionalString']['input']>;
  projectTypeId?: InputMaybe<Scalars['OptionalUUID']['input']>;
  quantity?: InputMaybe<Scalars['OptionalInt']['input']>;
  reference?: InputMaybe<Scalars['OptionalString']['input']>;
  resources?: UpdateResourcesInput;
  timeFactorId?: InputMaybe<Scalars['OptionalUUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureMilestoneInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  labelId?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureTaskInput = {
  assignees?: Array<ProcedureTaskAssigneeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['OptionalFloat']['input']>;
  name: Scalars['String']['input'];
  procedureTaskId: Scalars['UUID']['input'];
};

export type UpdateProducerInput = {
  contactDetails: ContactDetailsInput;
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateProjectAccessInput = {
  access: ProjectAccess;
  teamContributors?: InputMaybe<Array<TeamContributorInput>>;
  userContributors?: InputMaybe<Array<UserContributorInput>>;
};

export type UpdateProjectInput = {
  access?: InputMaybe<UpdateProjectAccessInput>;
  clients?: InputMaybe<Array<Scalars['UUID']['input']>>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  deadline: TimestampInput;
  executionDate?: InputMaybe<TimestampInput>;
  finalCost?: Scalars['String']['input'];
  hasPriority?: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
  image?: InputMaybe<SaveResourceInput>;
  isBomComplete?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  producers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  projectTypeId: Scalars['UUID']['input'];
  quantity?: InputMaybe<Scalars['OptionalInt']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  responsibleId: Scalars['UUID']['input'];
  shouldUpdateMilestonesDeadline?: Scalars['Boolean']['input'];
  startDate?: InputMaybe<TimestampInput>;
  status: Status;
  targetCost?: Scalars['String']['input'];
  timeFactorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateProjectMaterialInput = {
  additionalReferenceNumbers?: InputMaybe<Array<AdditionalReferenceNumberInput>>;
  consumption?: InputMaybe<Scalars['Float']['input']>;
  consumptions?: InputMaybe<Array<ProjectMaterialConsumptionInput>>;
  id: Scalars['UUID']['input'];
  isFulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullyOrdered?: InputMaybe<Scalars['Boolean']['input']>;
  isFullyReserved?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderReminder?: InputMaybe<TimestampInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceCurrency?: InputMaybe<Currency>;
  prices?: InputMaybe<Array<ProjectMaterialPriceInput>>;
  sizeMatrixItemIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  supplierId?: InputMaybe<Scalars['UUID']['input']>;
  targetDeadline?: InputMaybe<TimestampInput>;
  targetDeadlineMilestoneId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateProjectTypeInput = {
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateRecurringDefinitionInput = {
  assignees?: InputMaybe<Array<Scalars['UUID']['input']>>;
  createDaysBeforeDeadline: Scalars['Int']['input'];
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['OptionalFloat']['input']>;
  followers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  onDateOfYear?: InputMaybe<TimestampInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  recurringEnd?: InputMaybe<TimestampInput>;
  recurringPeriod: RecurringPeriod;
  recurringPeriodInterval: Scalars['Int']['input'];
  startDate: TimestampInput;
  status?: InputMaybe<RecurringStatus>;
  tasksConfig?: InputMaybe<Array<RecurringTaskConfigInput>>;
};

export type UpdateResourceAccessInput = {
  access: ResourceAccess;
  teamContributors: Array<TeamContributorInput>;
  userContributors: Array<UserContributorInput>;
};

export type UpdateResourceInput = {
  access?: InputMaybe<UpdateResourceAccessInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateResourcesInput = {
  deletedResourceIds?: Array<Scalars['UUID']['input']>;
  newResources?: Array<SaveResourceInput>;
};

export type UpdateSectionInput = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSignatureInput = {
  id: Scalars['UUID']['input'];
  images?: InputMaybe<Array<SaveResourceInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSizeInput = {
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSizeMatrixInput = {
  id: Scalars['UUID']['input'];
  items: Array<SizeMatrixItemInput>;
  name: Scalars['String']['input'];
  sizeStandardId: Scalars['UUID']['input'];
  status: Status;
};

export type UpdateSizeStandardInput = {
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSupplierInput = {
  contactDetails?: InputMaybe<ContactDetailsInput>;
  currency?: InputMaybe<Currency>;
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTaskInput = {
  deadline?: InputMaybe<OptionalTimestampInput>;
  description?: InputMaybe<Scalars['OptionalString']['input']>;
  estimatedHours?: InputMaybe<Scalars['OptionalFloat']['input']>;
  followers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['OptionalUUID']['input']>;
  status?: InputMaybe<Status>;
  teamFollowerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateTeamInput = {
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  members: Array<TeamMemberInput>;
  name: Scalars['String']['input'];
  teamLeadId: Scalars['UUID']['input'];
};

export type UpdateThreadDraftInput = {
  deletedResources?: Array<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  labelIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  newResources?: Array<SaveResourceInput>;
  teamRecipients?: InputMaybe<Array<Scalars['UUID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userRecipients?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateThreadInput = {
  alias?: InputMaybe<Scalars['OptionalString']['input']>;
  id: Scalars['UUID']['input'];
  labelIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastReadTime?: InputMaybe<TimestampInput>;
  remindAt?: InputMaybe<TimestampInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTimeFactorInput = {
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateWarehouseInput = {
  addressId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkCalendarExceptionPeriodInput = {
  endDate?: InputMaybe<TimestampInput>;
  id: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<TimestampInput>;
  type?: InputMaybe<WorkCalendarExceptionPeriodType>;
};

export type UsageReportInput = {
  from: TimestampInput;
  to: TimestampInput;
};

export type UsageReportRow = BaseUsageReportRow & {
  __typename?: 'UsageReportRow';
  account: Account;
  activeBoards?: Maybe<Scalars['Int']['output']>;
  activeProjects?: Maybe<Scalars['Int']['output']>;
  assignedGoals?: Maybe<Scalars['Int']['output']>;
  assignedTasks?: Maybe<Scalars['Int']['output']>;
  completedGoals?: Maybe<Scalars['Int']['output']>;
  completedTasks?: Maybe<Scalars['Int']['output']>;
  createdGoals?: Maybe<Scalars['Int']['output']>;
  createdTasks?: Maybe<Scalars['Int']['output']>;
  lateTasks?: Maybe<Scalars['Int']['output']>;
  receivedComments?: Maybe<Scalars['Int']['output']>;
  receivedNotifications?: Maybe<Scalars['Int']['output']>;
  sentComments?: Maybe<Scalars['Int']['output']>;
  unreadComments?: Maybe<Scalars['Int']['output']>;
  unreadNotifications?: Maybe<Scalars['Int']['output']>;
};

export enum UserAccess {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type UserContributor = {
  __typename?: 'UserContributor';
  access: UserAccess;
  account: Account;
};

export type UserContributorInput = {
  access: UserAccess;
  accountId: Scalars['UUID']['input'];
};

export type ValidateProjectImportResponse = ErrorsResponse | IntValue;

export type Warehouse = {
  __typename?: 'Warehouse';
  address: Address;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

export type WarehouseInventory = {
  __typename?: 'WarehouseInventory';
  freeQuantity: Scalars['Int']['output'];
  reservedQuantity: Scalars['Int']['output'];
  warehouse: Warehouse;
};

export type WarehouseMaterialInventories = {
  __typename?: 'WarehouseMaterialInventories';
  materials?: Maybe<Array<WarehouseMaterialInventory>>;
  meta: Metadata;
};

export type WarehouseMaterialInventoriesSetFiltersInput = {
  field: WarehouseMaterialInventoryField;
  filters?: Array<WarehouseMaterialInventoryFilterInput>;
};

export type WarehouseMaterialInventory = {
  __typename?: 'WarehouseMaterialInventory';
  material: Material;
  warehouseInventories: Array<WarehouseInventory>;
};

export enum WarehouseMaterialInventoryField {
  Client = 'CLIENT',
  Manufacturer = 'MANUFACTURER',
  MaterialReferenceNumber = 'MATERIAL_REFERENCE_NUMBER',
  MaterialType = 'MATERIAL_TYPE'
}

export type WarehouseMaterialInventoryFilterInput = {
  field: WarehouseMaterialInventoryField;
  operator: FilterOperator;
  values: Array<FilterValue>;
};

export enum Widget {
  Activity = 'ACTIVITY',
  Calendar = 'CALENDAR',
  Goal = 'GOAL',
  MyTeams = 'MY_TEAMS',
  Notification = 'NOTIFICATION',
  Task = 'TASK',
  Todo = 'TODO'
}

export type WorkCalendarExceptionPeriod = {
  __typename?: 'WorkCalendarExceptionPeriod';
  endDate: Timestamp;
  id: Scalars['UUID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  startDate: Timestamp;
  type: WorkCalendarExceptionPeriodType;
};

export enum WorkCalendarExceptionPeriodType {
  Holiday = 'HOLIDAY',
  Workday = 'WORKDAY'
}

export type OrganizationFragmentFragment = { __typename?: 'Organization', id: any, name: string, currency?: Currency | null, language: Language, providerId: string, enabledFeatures: Array<Feature>, createdAt?: { __typename?: 'Timestamp', seconds?: any | null } | null, logo?: { __typename?: 'Resource', id: any, presignedUrl?: string | null } | null };

export type AccountFragmentFragment = { __typename?: 'Account', id: any, isActive?: boolean | null, fullName?: string | null, email?: string | null, mobilePhone?: string | null, lang: Language, datePreferences?: string | null, timezone?: string | null, jobTitle?: { __typename?: 'JobTitle', id: any, name: string } | null };

export type AccountFullFragmentFragment = { __typename?: 'Account', id: any, isActive?: boolean | null, fullName?: string | null, email?: string | null, mobilePhone?: string | null, firstName?: string | null, lastName?: string | null, lang: Language, datePreferences?: string | null, timezone?: string | null, roles: Array<{ __typename?: 'Role', id: any, name: string }>, permissions: Array<{ __typename?: 'Permission', name: string, application: Application }>, profileImage?: { __typename?: 'Resource', id: any, presignedUrl?: string | null, thumbnailUrl?: string | null } | null, jobTitle?: { __typename?: 'JobTitle', id: any, name: string } | null };

export type CurrentUserAccountFragmentFragment = { __typename?: 'Account', id: any, isActive?: boolean | null, fullName?: string | null, email?: string | null, mobilePhone?: string | null, firstName?: string | null, lastName?: string | null, lang: Language, datePreferences?: string | null, timezone?: string | null, prodactiveEnabled: boolean, jobTitle?: { __typename?: 'JobTitle', id: any, name: string } | null, permissions: Array<{ __typename?: 'Permission', name: string, application: Application }>, profileImage?: { __typename?: 'Resource', id: any, presignedUrl?: string | null, thumbnailUrl?: string | null } | null };

export type BaseMilestoneFragmentFragment = { __typename?: 'BaseMilestone', id: any, name: string, isActive: boolean, isCheckpoint: boolean };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'Account', id: any, fullName?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null, lang: Language, datePreferences?: string | null, timezone?: string | null, permissions: Array<{ __typename?: 'Permission', name: string, application: Application }>, profileImage?: { __typename?: 'Resource', id: any, presignedUrl?: string | null, thumbnailUrl?: string | null } | null, jobTitle?: { __typename?: 'JobTitle', id: any, name: string } | null } | null };

export type DeleteResourcesMutationVariables = Exact<{
  input: DeleteResourcesInput;
}>;


export type DeleteResourcesMutation = { __typename?: 'Mutation', deleteResources?: { __typename?: 'DeleteResource', failedIds?: Array<any> | null } | null };

export type GetResourcePolicyQueryVariables = Exact<{
  input?: InputMaybe<GetResourcePolicyInput>;
}>;


export type GetResourcePolicyQuery = { __typename?: 'Query', getResourcePolicy?: { __typename?: 'ResourcePolicy', url?: string | null, key?: string | null, contentType?: string | null, filename?: string | null } | null };

export type GetCurrentUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserAccountQuery = { __typename?: 'Query', getCurrentUserAccount: { __typename?: 'Account', id: any, isActive?: boolean | null, fullName?: string | null, email?: string | null, mobilePhone?: string | null, firstName?: string | null, lastName?: string | null, lang: Language, datePreferences?: string | null, timezone?: string | null, prodactiveEnabled: boolean, organization: { __typename?: 'Organization', id: any, name: string, currency?: Currency | null, language: Language, providerId: string, enabledFeatures: Array<Feature>, createdAt?: { __typename?: 'Timestamp', seconds?: any | null } | null, logo?: { __typename?: 'Resource', id: any, presignedUrl?: string | null } | null }, jobTitle?: { __typename?: 'JobTitle', id: any, name: string } | null, permissions: Array<{ __typename?: 'Permission', name: string, application: Application }>, profileImage?: { __typename?: 'Resource', id: any, presignedUrl?: string | null, thumbnailUrl?: string | null } | null } };

export type CurrentAccountOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountOrganizationsQuery = { __typename?: 'Query', currentAccountOrganizations: Array<{ __typename?: 'Organization', id: any, name: string, providerId: string }> };

export type AllAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAccountsQuery = { __typename?: 'Query', allAccounts: Array<{ __typename?: 'Account', id: any, isActive?: boolean | null, fullName?: string | null, email?: string | null, mobilePhone?: string | null, firstName?: string | null, lastName?: string | null, lang: Language, datePreferences?: string | null, timezone?: string | null, roles: Array<{ __typename?: 'Role', id: any, name: string }>, permissions: Array<{ __typename?: 'Permission', name: string, application: Application }>, profileImage?: { __typename?: 'Resource', id: any, presignedUrl?: string | null, thumbnailUrl?: string | null } | null, jobTitle?: { __typename?: 'JobTitle', id: any, name: string } | null }> };

export type SearchBaseMilestonesQueryVariables = Exact<{
  input?: InputMaybe<SearchNomenclatureInput>;
}>;


export type SearchBaseMilestonesQuery = { __typename?: 'Query', searchBaseMilestones?: { __typename?: 'BaseMilestones', baseMilestones?: Array<{ __typename?: 'BaseMilestone', id: any, name: string, isActive: boolean, isCheckpoint: boolean }> | null } | null };

export type SearchSelectableProjectsQueryVariables = Exact<{
  input?: InputMaybe<SearchProjectsInput>;
}>;


export type SearchSelectableProjectsQuery = { __typename?: 'Query', searchProjects?: { __typename?: 'Projects', projects: Array<{ __typename?: 'Project', id: any, name: string, hasPriority: boolean, status: Status, projectType: { __typename?: 'ProjectType', id: any, name: string }, responsible: { __typename?: 'Account', id: any, isActive?: boolean | null, fullName?: string | null, email?: string | null, mobilePhone?: string | null, lang: Language, datePreferences?: string | null, timezone?: string | null, jobTitle?: { __typename?: 'JobTitle', id: any, name: string } | null }, assignedProducers: Array<{ __typename?: 'AssignedProducer', id: any, producer: { __typename?: 'Producer', id: any, name: string } }>, deadline: { __typename?: 'Timestamp', seconds?: any | null } }>, meta?: { __typename?: 'Metadata', pagination: { __typename?: 'Pagination', pageNumber?: number | null, pageSize?: number | null, totalElements?: any | null } } | null } | null };

export const OrganizationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"enabledFeatures"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]} as unknown as DocumentNode<OrganizationFragmentFragment, unknown>;
export const AccountFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"email"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"lang"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"datePreferences"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AccountFragmentFragment, unknown>;
export const AccountFullFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountFullFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"datePreferences"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"application"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AccountFullFragmentFragment, unknown>;
export const CurrentUserAccountFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUserAccountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"datePreferences"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"application"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"prodactiveEnabled"}}]}}]} as unknown as DocumentNode<CurrentUserAccountFragmentFragment, unknown>;
export const BaseMilestoneFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseMilestoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseMilestone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isCheckpoint"}}]}}]} as unknown as DocumentNode<BaseMilestoneFragmentFragment, unknown>;
export const UpdateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"datePreferences"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"application"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const DeleteResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteResourcesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteResources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failedIds"}}]}}]}}]} as unknown as DocumentNode<DeleteResourcesMutation, DeleteResourcesMutationVariables>;
export const GetResourcePolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getResourcePolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetResourcePolicyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getResourcePolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]} as unknown as DocumentNode<GetResourcePolicyQuery, GetResourcePolicyQueryVariables>;
export const GetCurrentUserAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentUserAccountFragment"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUserAccountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"datePreferences"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"application"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"prodactiveEnabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"enabledFeatures"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserAccountQuery, GetCurrentUserAccountQueryVariables>;
export const CurrentAccountOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentAccountOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentAccountOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}}]}}]}}]} as unknown as DocumentNode<CurrentAccountOrganizationsQuery, CurrentAccountOrganizationsQueryVariables>;
export const AllAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountFullFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountFullFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"datePreferences"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"application"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"nonreactive"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AllAccountsQuery, AllAccountsQueryVariables>;
export const SearchBaseMilestonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchBaseMilestones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchNomenclatureInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchBaseMilestones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseMilestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseMilestoneFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseMilestoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseMilestone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isCheckpoint"}}]}}]} as unknown as DocumentNode<SearchBaseMilestonesQuery, SearchBaseMilestonesQueryVariables>;
export const SearchSelectableProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSelectableProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchProjectsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasPriority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"projectType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedProducers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"email"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"lang"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"datePreferences"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchSelectableProjectsQuery, SearchSelectableProjectsQueryVariables>;